// en, de, fr, pt
export default {
    en: {
        automation: {
            parameters: 'Automation parameters',
            automation_type: 'Automation type',
            minutes: 'Minutes',
            hours: 'Hours',
            start_time: 'Start time',
            days_of_week: 'Days of week',
            days_of_month: 'Days of month',
            number_of_days: 'Number of days',
            relative_number_of_days_in_period_start: 'Number of days to period start',
            relative_number_of_days_in_period_end: 'Number of days to period end',
            leads_count: 'Leads count',
            every_minute: 'Every minute',
            hourly: 'Every hour',
            daily: 'Every day',
            weekly: 'Every week',
            monthly: 'Every month',
            name: 'Name',
            start: 'Last start',
            end: 'Last finish'
        },
        loads: {
            deposits: 'Deposits',
            overpayment: 'Overpayment',
            statuses: 'Statuses',
            statuses_count: 'Statuses count'
        },
        sideMenu: {
            Settings_System: 'System Settings',
            Changes: 'Changes',
            Logs: 'Logs',
            Home: 'Home',
            Dashboard: 'Dashboard',
            Dashboard_Top_management: 'Top management',
            Dashboard_Team_lead: 'Team lead',
            Affiliate: 'Affiliate',
            Statistic: 'Statistics',
            Statistic_Main: 'Main',
            Statistic_Leads: 'Leads',
            Leads: 'Leads',
            System_health: 'System health',
            Advertiser: 'Advertiser',
            Falcon: 'Falcon',
            Team: 'Team',
            Offers: 'Offers',
            Domains: 'Domains',
            Landings: 'Landings',
            Settings: 'Settings',
            Settings_Teams: 'Teams',
            Settings_Caps: 'Caps',
            Settings_Landings: 'Landings',
            Settings_Domains: 'Domains',
            Settings_Hold: 'Hold',
            Settings_Geo: 'Geo',
            Users: 'Users',
            Campaigns: 'Campaigns',
            Check: 'Verification',
            TestLead: 'Check lead',
            Faicon: 'FaIcon',
            Deposits: 'Deposits',
            Finance: 'Finance',
            Permissions: 'Permissions',
            Postbacks: 'Postbacks',
            Management: 'Management',
            Cards: 'Cards',
            SMS: 'SMS',
            Messages: 'Messages',
            Analytics: 'Analytics',
            Statuses: 'Statuses',
            Settings_Management: "Management",
            Loads: 'Loads',
            Recycle: 'Recycle',
            Deals: 'Deals',
            Uploads: 'Uploads',
            Moderation: 'Moderation',
            Notifications: 'Notifications'
        },
        campaigns: {
            Approve_status: 'Approve status',
            Approve: 'Approve',
            Standard: 'Standard',
            Landing_path: 'Landing path',
            Platforms: 'Platforms',
            Url: 'URL',
            Tracker: 'Tracker',
            Cloaking: 'Cloaking'
        },
        settings: {
            Stream_strength: 'Stream strength',
            In_process: 'In process',
            Paused: 'Paused',
            Landing_status: 'Landing status',
            Clear_version: 'Clear version',
            Domain_status: 'Domain status',
            Offer_status: 'Offer status',
            Start: 'Start',
            End: 'End',
            New: 'New',
            Old: 'Old',
            Timing: 'Timing'
        },
        statistic: {
            External_status: 'External status',
            CvStatistic: 'Team conversion',
            Traffic_by_advertiser: 'Traffic by advertiser',
            Traffic_by_user_team: 'Traffic by user/team',
            Traffic_by_offer: 'Traffic by offer',
            Deposits_by_advertiser: 'Deposits by advertiser',
            Deposits_by_user_team: 'Deposits by user/team',
            Deposits_by_offer: 'Deposits by offer',
            Hold_by_geo: 'Hold by geo',
            Offer_domain_deps: 'Domain deposits by offers',
            Top_5_affiliates: 'Top 5 affiliates by traffic',
            Top_5_teams: 'Top 5 teams by traffic',
            Top_5_offers: 'Top 5 offers by traffic',
            Person: 'Person',
            Lang: 'Lang',
            ADV_INT: 'ADV/INT',
            SYS_Status: 'SYS Status',
            ERR_Status: 'Error Status',
            ADV_Status: 'ADV Status',
            Reg_date: 'Reg date',
            Advertiser_status: 'Advertiser status',
            Advertiser_statuses: 'Advertiser statuses',
            Advertiser_traffic: 'Advertiser traffic',
            Advertiser_traffic_by_hour: 'Advertiser traffic by hour distribution',
            Sync: 'Sync',
            Group_Status: 'Group status',
            Statuses_Statistic: 'Statistics by status',
            Statuses_Countries: 'Statistics by countries',
            Validation_errors: 'Validation errors',
            guarantee: 'Guarantee',
            advertiser_geoconversion: 'Advertiser geoconversion'
        },
        modals: {
            Edit_System_Settings: 'Edit system settings',
            editSchedule: 'Edit schedule',
            Recycle: 'Recycle leads',
            Advertiser_modal_button: 'Save advertiser',
            Integration_modal_button: 'Save integration',
            Advertiser_name: 'Advertiser name',
            Safe_name: 'Safe name',
            Falcon_integration: 'Falcon integration',
            Falcon_statistic: 'Falcon statistic',
            Description: 'Description',
            Login: 'Login',
            URL: 'URL',
            Password: 'Password',
            Choose_model: 'Choose model',
            Choose_geo: 'Choose GEO',
            Choose_countries: 'Choose countries',
            Choose_accepted_offers: 'Choose accepted offers',
            Choose_name: 'Choose name',
            Choose_not_accepted_offers: 'Choose NOT accepted offers',
            Choose_team: 'Choose team',
            Choose_affiliate: 'Choose affiliate',
            Choose_affiliates: 'Choose affiliates',
            Choose_offer: 'Choose offer',
            Choose_language: 'Choose language',
            Choose_landing: 'Choose landing',
            Choose_prelanding: 'Choose prelanding',
            Choose_domain: 'Choose domain',
            Choose_url: 'Choose url',
            Choose_cloaking: 'Choose cloaking',
            Choose_postback: 'Choose postback',
            Choose_platform: 'Choose platform',
            Enter_landing_name: 'Enter landing name',
            Landing_name: 'Landing name',
            Enter_domain: 'Enter domain name',
            Domain_name: 'Domain name',
            Enter_offer_name: 'Enter оffer name',
            Offer_name: 'Offer name',
            Enter_campaign_name: 'Enter campaign name',
            Campaign_name: 'Campaign name',
            Enter_campaign_identifier: 'Enter campaign identifier',
            Campaign_identifier: 'Campaign identifier',
            Geo_name: 'Geo name',
            Enter_geo_name: 'Enter geo name',
            Set_schedule: 'Set schedule',
            Enter_test: 'Enter test',
            From: 'From',
            To: 'To',
            Confirm_password: 'Confirm password',
            Team_name: 'Team name',
            Manager_name: 'Manager name',
            Self: 'Self',
            First_name: 'First name',
            Last_name: 'Last name',
            Phone: 'Phone',
            IP: 'IP',
            Preview_url: 'Preview url',
            Enter_preview_url: 'Enter preview url',
            Source_url: 'Source url',
            Enter_source_url: 'Enter source url',
            Companies_Removed: 'These companies will be removed',
            Transfer_domain: 'Transfer domain',
            Token: 'Token',
            card_logs: 'Card Logs',
            Edit_lead: 'Edit lead',
            Lead_info_integration: 'Lead Info Integration',
            Send_to_trash: 'Send to trash?',
            Edit_advertiser: 'Edit advertiser',
            Global_update_time: 'Global time update',
            Edit_integration: 'Edit integration',
            Сopy_integration: 'Сopy integrations',
            Edit_team: 'Edit team',
            Manager_info: 'Manager information',
            Add_offer: 'Add offer',
            Edit_offer: 'Edit offer',
            Edit_landing: 'Edit landing',
            Edit_domain: 'Edit domain',
            Edit_geo: 'Edit geo',
            Create_module: 'Add module',
            Edit_module: 'Edit module',
            Add_permission: 'Add permission',
            Create_message: 'Add message',
            Edit_message: 'Edit message',
            Create_settings: 'Add settings',
            Update_settings: 'Update settings',
            Add_tracker: 'Add tracker',
            Edit_user: 'Edit user',
            Edit_user_permission: 'Edit user permission',
            Update_password: 'Update password',
            Edit_campaign: 'Edit campaign',
            Edit_postback: 'Edit postback',
            Postback_logs: 'Postback logs',
            Add_hold: 'Add hold',
            Edit_hold: 'Edit hold',
            Edit_permission: 'Edit permission',
            Lead_info: 'Lead info',
            Lead_comments: 'Comments',
            Lead_history_statuses: 'Status History',
            Edit_relation: "Edit relation",
            Global_update_int: "Bulk replacement of requisites",
            Edit_Status: "Edit status",
            CloneAdv: "Cloning of the advertiser",
            list_relation: "List of relation",
            Hot: 'Hot',
            Team_status: "Team status",
            autologin_info: "Autologin info",
            lead_synchronization_enable: "Enable lead synchronization",
            lead_synchronization_disable: "Disable lead synchronization",
        },
        buttons: {
            Copy_log: 'Copy log',
            ForceSendLead: 'Force send a lead',
            OpenNew: 'Open',
            Create_integration: 'Add integration',
            Save_integration: 'Save integration',
            Create_advertiser: 'Add advertiser',
            Save_advertiser: 'Save advertiser',
            Save_campaign: 'Save campaign',
            Create_campaign: 'Add campaign',
            Save_team: 'Save team',
            Create_team: 'Add team',
            Create_user: 'Add user',
            Save_user: 'Save user',
            Create_offer: 'Add offer',
            Save_offer: 'Save offer',
            Add_integration: 'Add integration',
            Add_landing: 'Add landing',
            Save_landing: 'Save landing',
            Add_prelanding: 'Add prelanding',
            Add_domain: 'Add domain',
            Save_domain: 'Save domain',
            Add_geo: 'Add geo',
            Save_geo: 'Save geo',
            Copy_link: 'Copy link',
            Show: 'Show',
            Test: 'Test',
            Save: 'Save',
            Update: 'Update',
            Transfer: 'Transfer',
            Add_postback: 'Add postback',
            Submit: 'Submit',
            Management: 'Management',
            Create_card: 'Create card',
            Edit_card: 'Edit card',
            Reset_queue: 'Reset queue',
            Activate: 'Activate',
            Deactivate: 'Deactivate',
            Approve: 'Approve',
            Disapprove: 'Disapprove',
            Add: 'Add',
            Delete: 'Delete',
            Clear: 'Clear',
            Refresh: 'Refresh',
            Show_disabled_integrations: 'Show disabled integrations',
            Search: 'Search',
            Add_parameter: 'Add parameter',
            Filter: 'Filter',
            Open: 'Open',
            Close: 'Close',
            Change: 'Change',
            Logout: 'Logout',
            Create_Relation: "Create relation",
            Create_status: "Add status",
            editCap: "Edit cap",
            saveCap: "Save cap",
            generatePassword: "Generate new password",
            showPassword: "Show password",
            hidePassword: "Hide password",
            downloadReport: 'Download report',
            time: 'Show schedule',
            notTime: 'Show caps',
            sync: 'Synchronize',
            Decline: 'Decline',
            DownloadTemplate: 'Download template'
        },
        global: {
            Conditions: 'Conditions',
            MonthDay: 'Month Day',
            Hours: 'Hours',
            Minutes: 'Minutes',
            month: "Month",
            play: 'Play',
            pause: 'Pause',
            leadSamplingParameters: "Lead sampling parameters",
            sendingOptions: "Sending options",
            automation: 'Automation',
            menuItem: 'Menu item',
            Selected: 'Selected',
            Entity: 'Entity',
            Data: 'Data',
            Method: 'Method',
            title: 'Title',
            Straight: 'Straight',
            uploadsLeads: 'Uploads leads',
            statusLeads: 'Status leads',
            Priority: 'Priority',
            land_id: 'LAND_ID',
            CapsByGeo: 'Caps by geo',
            CapsByCountry: 'Caps by country',
            Multiple: 'Multiselect',
            Separator: 'Separator',
            globalUpdate: 'Mass action',
            Conversion: 'Conversion %',
            Day: 'Day',
            Templates: 'Templates',
            // Page elements
            Login: 'Login',
            Welcome: 'Welcome!',
            Filters: 'Filters',
            All: 'All',

            // Table elements
            Status: 'Status',
            System_status: 'System status',
            ERROR_status: 'Error status',
            ADV_history: 'ADV history',
            Actions: 'Actions',
            Action: 'Action',
            User: 'User',
            Users: 'Users',
            Name: 'Name',
            Team: 'Team',
            Teams: 'Teams',
            Role: 'Role',
            Roles: 'Roles',
            Role_access: 'Role access',
            Hold: 'Hold',
            Deposits: 'Deposits',
            Depositors: 'Deposits',
            Invalid: 'Invalid',
            CR: 'CR',
            IR: 'IR',
            Operation: 'Operation',
            // Common words
            Affiliate: 'Affiliate',
            Offer: 'Offer',
            Offers: 'Offers',
            Landing: 'Landing',
            Landings: 'Landings',
            Prelanding: 'Prelanding',
            Prelandings: 'Prelandings',
            Advertiser: 'Advertiser',
            Advertisers: 'Advertisers',
            Geo: 'Geo',
            Model: 'Traffic model',
            model: 'Model',
            Domain: 'Domain',
            Domain_leads: 'Domain leads',
            Integration: 'Integration',
            Integrations: 'Integrations',
            Integration_Status: 'Integration status',
            Integration_Parameters: 'Integration parameters',
            Settings_active: 'Settings active',
            Lead: 'Lead',
            Leads: 'Leads',
            'Leads%': 'Leads %',
            Date: 'Date',
            Schedule: 'Schedule',
            Payment: 'Payment',
            Identifier: 'Identifier',
            Country: 'Country',
            Countries: 'Countries',
            Language: 'Language',
            Languages: 'Languages',
            Managers: 'Managers',
            Group_statuses: 'Statuses',
            Save: 'Save',
            Reset: 'Reset',
            Cancel: 'Cancel',
            Of: 'of',
            //
            Registration_date: 'Registration date',
            Send_date: 'Send date',
            Deposit_date: 'Deposit date',
            From_hold: 'From hold',
            Synchronize: 'Synchronize',
            Search: 'Search...',
            Permissions: 'Permissions',
            Domains: 'Domains',
            Email: 'E-mail',
            Locale: 'System language',
            Preview: 'Preview',
            Campaign: 'Campaign',
            Campaigns: 'Campaigns',
            Affiliates: 'Affiliates',
            Total: 'Total',
            Slug: 'Slug',
            Custom_slug: 'Custom slug',
            Description: 'Description',
            Event: 'Event',
            Type: 'Type',
            Custom: 'Custom',
            Copy_url: 'Copy url',
            typeName: 'Type name',
            bankName: 'Bank name',
            holderName: 'Holder name',
            statusName: 'Status name',
            platformName: 'Platform name',
            newTypeName: 'New type name',
            newBankName: 'New bank name',
            newHolderName: 'New holder name',
            newInvoiceNumber: 'New invoice number',
            newStatus: 'New status',
            newPlatformName: 'New platform name',
            card: 'Card',
            bank: 'Bank',
            holder: 'Holder',
            invoice: 'Invoice',
            invoiceNumber: 'Invoice number',
            code: 'Code',
            status: 'Status',
            number: 'Number',
            manager: 'Manager',
            cvv: 'CVV',
            comment: 'Comment',
            create: 'Create',
            edit: 'Edit',
            edit_message: 'Edit message',
            remove_message: 'Remove message',
            remove: 'Remove',
            remove_data: 'Remove data',
            remove_card: 'Remove card?',
            owner: 'Owner',
            link_id: 'Link ID',
            landing_url: 'Landing Url',
            params_url: 'URL params',
            message: 'Message',
            Start: 'Start',
            End: 'End',
            Traffic_Type: 'Traffic type',
            offer: 'Offer',
            platform: 'Platform',
            dateCreate: 'Date create',
            changeManager: 'Change manager or platform',
            view: 'View',
            totalLeads: 'Total leads',
            active: 'Active',
            inactive: 'Inactive',
            No_data: 'No data!',
            PCT: 'PCT',
            Disabled: 'Disabled',
            Time: 'Time',
            API: 'API',
            Copy: 'Copy!',
            Value: 'Value',
            Default_Value: 'Default value',
            Information: 'Information',
            Download: 'Download',
            Action_date: 'FTD',
            TMP_Action_date: 'Tmp FTD',
            Supplements: 'Supplements',
            Lights: 'Lights',
            today: 'Today',
            "Post deposits": 'Post deposits',
            response: 'Lead',
            history_response: 'Advertiser`s response',
            send: 'Sent',
            not_send: 'Not sent',
            Manager: 'Affiliate manager',
            Endpoint: 'Endpoint',
            Internal_status: 'Internal status',
            External_status: 'External status',
            campaign_identifier: 'Campaign identifier',
            globalEditCaps: 'Global update caps',
            type: 'Type',
            guarantee: 'Guarantee',
            no_guarantee: 'No guarantee',
            id: 'ID',
            Team_ID: 'Team ID',
            Group_status: 'Group status',
            Internal: 'Internal',
            External: 'External',
            Country_Language: 'Country/Language',
            byGeo: 'By geo',
            Advertiser_category: 'Advertiser category',
            Category: 'Category',
            submitted_fields: 'Fields to send',
            capsByGeo: 'Caps by geo',
            capsByTeams: 'Caps by teams',
            capsByCountries: 'Caps by countries',
            capsAll: 'All caps',
            acceptDuplicates: 'Accept duplicates'
        },
        permissions: {
            settings_system: 'System Settings',
            logs: 'Logs',
            finance_access: 'Finance',
            campaign: 'Campaigns',
            dashboard_affiliate: 'A dashboard',
            dashboard_team_leader: 'TL dashboard',
            dashboard_top_management: 'TM dashboard',
            domain: 'Domains',
            finance: 'Finance',
            landing: 'Landings',
            offer: 'Offers',
            team: 'Team',
            statistic_advertiser: 'Advertisers statistics',
            statistic_affiliate: 'Affiliate statistic',
            statistic_lead: 'Lead statistic',
            statistic_offer: 'Offer statistic',
            statistic_falcon: 'Falcon',
            user: 'Users',
            settings_advertiser: 'S Advertiser',
            settings_cap: 'S Cap',
            settings_geo: 'S Geo',
            settings_offer: 'S Offer',
            settings_team: 'S Team',
            settings_domain: 'S Domain',
            settings_landing: 'S Landing',
            settings_hold: 'S Hold',
            settings_campaign_approve: 'S Campaign approve',
            check_lead: 'Check lead',
            permission: 'Create permission',
            system_status: 'System health',
            postback: 'Postback',
            finance_cards: 'Finance Cards',
            settings_sms_messages: 'Settings sms messages',
            settings_sms_settings: 'Settings sms settings',
            finance_analytic_access: 'Financial analytics',
            settings_management: 'S management',
            settings_status_mapper: 'S status mapper',
            loads: 'Loads',
            recycle_leads: 'Recycle',
            uploads: 'Uploads',
            uploads_falcon: 'Upload falcon',
            uploads_recycle: 'Upload recycle',
            lead_upload_falcon: 'Lead upload falcon',
            settings_moderation: 'S Moderation',
            affiliate_bot: 'Affiliate notifications'
        },
        calendar: {
            Week: 'Week',
            daysOfWeek: {
                Sunday: 'Sunday',
                Monday: 'Monday',
                Tuesday: 'Tuesday',
                Wednesday: 'Wednesday',
                Thursday: 'Thursday',
                Friday: 'Friday',
                Saturday: 'Saturday'
            },
            daysOfWeek_short: {
                Sun: 'Sun',
                Mon: 'Mon',
                Tue: 'Tue',
                Wed: 'Wed',
                Thu: 'Thu',
                Fri: 'Fri',
                Sat: 'Sat'
            },
            weekdaysMin: {
                Su: 'Su',
                Mo: 'Mo',
                Tu: 'Tu',
                We: 'We',
                Th: 'Th',
                Fr: 'Fr',
                Sa: 'Sa'
            },
            monthNames_short: {
                Jan: 'Jan',
                Feb: 'Feb',
                Mar: 'Mar',
                Apr: 'Apr',
                May: 'May',
                Jun: 'Jun',
                Jul: 'Jul',
                Aug: 'Aug',
                Sep: 'Sep',
                Oct: 'Oct',
                Nov: 'Nov',
                Dec: 'Dec'
            },
            sidebar: {
                today: 'Today',
                yesterday: 'Yesterday',
                this_month: 'This month',
                last_month: 'Last month',
                this_year: 'This year'
            },
            Apply: 'Apply',
            Cancel: 'Cancel'
        },
        system_health: {
            without_advertiser_status: 'Sent without status',
            without_group_status: 'Sent without group status',
            not_valid: 'Not valid',
            without_internal_price: 'No internal price',
            without_external_price: 'No external price',
            fa_date_without_gstatus: 'With date of deposit, no status',
            gstatus_without_fa_date: 'With status, no date of deposit',
            multiple_success_send: 'Resending'
        },
        error: {
            duplicate_country_and_lenguage_in_geo: 'Country {country} with language {language} is selected in the geo - {geo} ',
            no_changed_new_owner_or_platform: 'The owner or platform must be different from the current',
            messageErrorDomain: 'Invalid domain name',
            messageDuplicateDomain: 'Duplicate domain name'
        },
        statistic_fields: {
            geo: 'Geo',
            send: 'Send',
            sub1: 'Sub1',
            sub2: 'Sub2',
            sub3: 'Sub3',
            sub4: 'Sub4',
            sub5: 'Sub5',
            sub6: 'Sub6',
            sub7: 'Sub7',
            sub8: 'Sub8',
            sub9: 'Sub9',
            offer: 'Offer',
            domain: 'Domain',
            status: 'Status',
            actions: 'Actions',
            country: 'Country',
            landing: 'Landing',
            a_status: 'A_status',
            language: 'Language',
            personal: 'Lead',
            s_status: 'S_status',
            affiliate: 'Affiliate',
            advertiser: 'Advertiser',
            adv_history: 'Adv_history',
            registration: 'Registration',
            sms: 'SMS',
            id: 'ID',
            lead_id: 'Lead ID'
        },
        card_statuses: {
            new: 'New',
            active: 'Active',
            inactive: 'Inactive',
            closed: 'Closed',
            unknown: 'Unknown status'
        },
        table: {
            No_data_available: 'No data Available!',
            AVG_Price: 'AVG Price',
            CR: 'CR%',
            sendedLeads: 'Sended',
            duplicateLeads: 'Duplicate',
            trash: 'Trash',
            team_ID: 'Team ID',
            Traffic_model: 'Traffic madel',
            Is_internal: 'Is internal',
            Is_internal_team: 'Is internal',
            Global_status: 'Global status',
            Global_actions: 'Global actions',
            Total_cap: 'Total cap',
            Campaign_ID: ' Campaign ID',
            Ex_price: 'Ex. price',
            Int_price: 'Int. price',
            Internal_price_summ: 'Int. summ',
            External_price_summ: 'Ex. summ',
            isHot: 'Hot traffic',
            autologin: 'Autologin'
        },
        tooltip: {
            allStatuses: 'For all statuses',
            Download_CSV: 'Download CSV',
            Watch_full_stats: 'Watch full statistics',
            Copy: 'Copy',
            Copy_password: 'Copy password',
            Show: 'Show',
            Hide: 'Hide',
            Reset_filter: 'Reset filter',
            Refresh_table: 'Refresh table',
            Delete_integration: 'Delete integration',
            Start_traffic: 'Start traffic',
            Stop_traffic: 'Stop traffic',
            Update_traffic: 'Update traffic',
            Add_country_and_language: 'Add country and language',
            Delete_country_and_language: 'Delete country and language',
            Active_card: 'Active card',
            Deactive_card: 'Deactive card',
            Change_owner_or_platform: 'Change owner or platform',
            Close_card: 'Close card',
            Login_as_this_user: 'Login as this user',
            Download_list_domains: 'Download list domains',
            Temporary_depositor: 'Temporary depositor',
            Comment: 'Comment',
            add_param: 'Add parameter',
            delete_param: 'Delete parameter',
            delete_advertiser: 'Delete advertiser',
            Group_by_advertiser: 'Group by advertiser',
            Undo_grouping: 'Undo grouping',
            Delete: 'Delete',
            detailsTeam: 'List of teams',
            detailsAdvertisers: 'List of advertisers',
            toTrash: 'Send to trash',
            clearErrors: 'Clear errors',
            cold_traffic: 'Low priority',
            edit_time: 'Edit time',
            updateStatus: 'Update ADV statuses',
            scheduling_caps: "Scheduling caps",
            set_caps: "Set caps",
            statusPart: "There are low priority deals",
            statusAll: "All low priority deals",
            statusNone: "No low priority deals",
            lowPriority: "Low priority",
            highPriority: "High priority",
            view: 'Review',
            upload: 'Upload',
            remove: 'Remove',
            Resend: 'Resend',
            reindexing: 'Reindexing'
        },
        confirm: {
            removeAutomation: 'You are about to remove automation!',
            deactivateStatus: 'You are about to DEACTIVATE the system status!',
            activateStatus: 'You are about to ACTIVATE the system status!',
            Confirm_action: 'Confirm action',
            activateAdvertiser: 'You are about to ACTIVATE advertiser!',
            deactivateAdvertiser: 'You are about to DEACTIVATE advertiser!',
            activateIntegration: 'You are about to ACTIVATE integration!',
            deactivateIntegration: 'You are about to DEACTIVATE integration!',
            deleteIntegration: 'You are about to DELETE integration!',
            clearQueue: 'Are you sure you want to clear the queue?',
            refreshTraffic: 'Refresh traffic in this integration?',
            stopTrafficOnIntegration: 'STOP traffic on this integration?',
            startTrafficOnIntegration: 'START traffic on this integration?',
            btnStopTrafficOnIntegration: 'Stop',
            btnStartTrafficOnIntegration: 'Start',
            deactivateOffer: 'You are about to DEACTIVATE offer!',
            activateOffer: 'You are about to ACTIVATE offer!',
            deactivateLanding: 'You are about to DEACTIVATE landing!',
            activateLanding: 'You are about to ACTIVATE landing!',
            deactivateDomain: 'You are about to DEACTIVATE domain!',
            activateDomain: 'You are about to ACTIVATE domain!',
            deleteMessage: 'Are you sure you want to delete this post?',
            deleteMessageSettings: 'Are you sure you want to delete this settings?',
            deactivateUser: 'You are about to DEACTIVATE user!',
            activateUser: 'You are about to ACTIVATE user!',
            activatePostback: 'You are about to ACTIVATE postback!',
            deactivatePostback: 'You are about to DEACTIVATE postback!',
            deactivateСampaign: 'You are about to DEACTIVATE campagin!',
            activateСampaign: 'You are about to ACTIVATE campaign!',
            disapproveСampaign: 'You are about to DISAPPROVE campaign!',
            approveСampaign: 'You are about to APPROVE campaign!',
            deactivateСard: 'Are you sure you want to DEACTIVATE card?',
            activateСard: 'Are you sure you want to ACTIVATE card?',
            deactivateHold: 'You are about to DEACTIVATE hold!',
            activateHold: 'You are about to ACTIVATE hold!',
            closeCard: 'Are you sure you want to CLOSE card?',
            openCard: 'Are you sure you want to OPEN card?',
            changeOwnerOrPlatform: 'You are about to change manager or platform!',
            deactivateTeam: 'You are about to DEACTIVATE team!',
            activateTeam: 'You are about to ACTIVATE team!',
            destroyAdvertiser: 'Are you sure you want to DELETE advertiser?',
            clearErrors: 'Are you sure you want to CLEAR errors?',
            removeLeads: 'Are you sure you want to delete all leads?',
            confirm: 'Confirm'
        },
        label: {
            Sync_available: 'Sync available',
            Only_hot_trafic: 'Only hot trafic',
            team_status: 'Team status',
            Choose_advertiser: 'Choose advertiser',
            Choose_integration: 'Choose integration',
            External_price: 'External price',
            Internal_price: 'Internal price',
            percent: 'Percent',
            guarantee: 'Guarantee',
            new_path: 'New path',
            Free_domains: 'Free domains',
            Event_type: 'Event type',
            Parameter_name: 'Parameter name',
            Postbacks: 'Postbacks',
            Advertisers_history: 'Advertisers history',
            Unvalid: 'Invalid/%',
            Valid: 'Valid',
            Summ: 'Summ',
            changeParameter: 'Change parameter',
            enterKey: 'Enter key',
            enterValue: 'Enter value',
        },
        page_404: {
            Title: '404 - Page Not Found!',
            Back_previous: 'Back to previous page',
            Back_home: 'Back to Home'
        },
        not_authorized: {
            Title: 'You are not authorized!'
        },
        table_filters: {
            sub: 'Sub',
            affiliate_name: 'Affiliate',
            advertisers: 'Advertiser',
            advertisers_categories: 'Advertiser Category',
            affiliates: 'Affiliate',
            countries: 'Country',
            external_price: 'External price',
            geos: 'Geo',
            geo: 'Geo',
            integrations: 'Integration',
            internal_price: 'Internal price',
            statuses: 'Status',
            traffic_models: 'Traffic model',
            advertiser_id: 'Advertiser',
            domains: 'Domain',
            advertiser_integration_id: 'Integration',
            traffic_model_id: 'Traffic model',
            team_id: 'Team',
            teams: 'Team',
            affiliate_hash: 'Affiliate',
            group_statuses: 'Status',
            language: 'Language',
            country: 'Country',
            offer_name: 'Offer',
            offers: 'Offer',
            landing_name: 'Landing',
            group_status: 'Status',
            team_name: 'Team',
            role_name: 'Role',
            active_name: 'Status',
            affiliate_id: 'Affiliate',
            advertiser_integration: 'Integration',
            domain: 'Domain',
            affiliate: 'Affiliate',
            offer: 'Offer',
            languages: 'Language',
            approve: 'Approve',
            status: 'Status',
            manager_id: "Affiliate manager",
            guarantee: 'Guarantee',
            advertiser_categories: 'Advertiser categories',
            email: 'Email',
            first_name: 'First name',
            last_name: 'Last Name',
            lead_id: 'Lead id',
            lead_status: 'Status',
            phone: 'Phone',
            currency: 'Currency',
            pay_out: 'Pay out',
            manager: 'Manager'
        },
        server_filter: {
            advertisers: 'Advertiser',
            integrations: 'Integration',
            traffic_models: 'Traffic models',
            affiliate_id: 'Affiliate',
            affiliates: 'Affiliate',
            geos: 'Geo',
            teams: 'Team',
            offers: 'Offer',
            domains: 'Domain',
            advertiser_integration: 'Integration',
            affiliate_name: 'Affiliate',
            countries: "Country",
            status: 'Status',
            approve: 'Approve',
            language: 'Language',
            languages: 'Language',
            affiliate: 'Affiliate',
            offer: 'Offer',
            domain: 'Domain',
            all: 'All',
            is_active: "Status",
            is_approved: "Approve"
        },
        validationErrors: {
            unique: 'The value must be unique',
            floatOrInteger: 'Field {name} is not valid',
            integer: 'Field {name} must be an integer',
            required: 'The {name} field is required',
            minmax: 'Min {minimum}, max {maximum}',
            max_value: 'Maximum value: {max}',
            min: 'Minimum value: {min}',
            max: 'Maximum value: {max}',
            email: 'Incorrect email address',
            is_not: 'The value is invalid',
            confirmed: '{target} does not match',
            ip: 'Incorrect IP address',
            numeric: 'The {name} field is numeric',
            negativeNumber: 'Field {name} cannot be a negative number',
            url: 'Incorrect url address',
            incorrect_value: 'Incorrect value',
            incorrect_card_number: 'Incorrect card number',
            incorrect_cvv: 'Invalid CVV',
            errorAddTitle: 'Domains not added',
            string: 'The {name} field must be a string',
            incorrect_phone_number: 'Wrong phone number',
            maxNum: 'Exceeded maximum value of { target }',
            minNum: 'The minimum value cannot be less than {target}',
            gte: 'The value must be greater than or equal field: {targetName}'
        },
        bgErrors: {
            different: 'The field must be unique',
            unique: 'The field must be unique',
            integer: 'The field must be an integer',
            required: 'The field must be filled',
            max: 'Exceeded the maximum limit',
            regex: 'Incorrect format',
            uniqueDomain: 'Such a domain already exists',
            unknown: 'Unknown error'
        },
        notification: {
            error: 'Error',
            success: 'Copied!',
            errorMessage: 'Something went wrong!'
        },
        leadCount: {
            'sended': 'Sended',
            'hold': 'Hold',
            'not_valid': 'Not valid',
            'trash': 'Trash',
            'duplicate': 'Duplicate',
            'double': 'Duplicate',
            'leads': 'Sended',
            'pending': 'In reshipment',
            'sent': 'Forwarded',
            'failed': 'Send error',
            'sended_false': 'Rejected'
        },
        date: {
            send_date: "By sent date",
            created_at: "By registration date",
            first_action_date: "By deposit date"
        },
        tab: {
            internal_response: 'Internal response',
            external_response: 'External response',
            lead_test: 'Lead test',
            sync_status: 'Sync test'
        },
        upload: {
            title: 'Drag and drop or select the required file.',
            size: 'The file size should not exceed {size} MB.',
            notValidFields: 'CSV has invalid fields!',
            notValidUniqueFields: 'CSV has duplicate fields!'
        },
        system_settings: {
            'category': {
                thank_you_page: 'Thank you page',
                settings_teams: 'Settings -> Teams',
                settings_advertisers: 'Settings -> Advertisers',
                logs: 'Logs',
                lead_acceptance: 'Lead acceptance',
                global: 'Global',
                finance_analytics: 'Finance_analytics',
                lead_expiration_status: 'Lead expiration status'
            },
            'title': {
                'is_falcon_long-term_synchronization_allowed': 'Long-term Falcon status synchronization',
                'is_demo_data_allowed': 'Is demo data allowed?',
                'lead_blacklist_ip': 'IP Blacklist',
                'invalid_statuses': 'Invalid statuses',
                'write_integration_statuses_history_log': 'Write log about synchronized lead statuses',
                'clean_request_logs_after_days': 'Request logs lifetime in days',
                'clean_version_logs_after_days': 'Version logs lifetime in days',
                'clean_lead_logs_after_days': 'Lead logs lifetime in days',
                'teams_with_required_lead_ip': 'Teams with required field lead ip on lead creation',
                'thank_you_page_expired_url': 'Thank you page expired url',
                'thank_you_page_url_lifetime_minutes': 'Thank you page expired lifetime minutes',
                'teams_show_users': 'Show users',
                'teams_show_integrations': 'Show integrations',
                'advertisers_show_integrations_and_geo': 'Show integrations and geo',
                'lead_duplicate_check_days_prior': 'Lead duplicate check period (days)',
                'lead_duplicate_check_days_prior_for_deposit': 'Lead duplicate check period for deposits (days)',
                'lead_expiration_status_after_days_for_falcon': 'Lead expiration (days) for Falcon',
                'lead_expiration_status_after_days_for_non_falcon': 'Lead expiration (days) for non-Falcon',
                'lead_expiration_status_changeable_statuses_list': 'Changeable lead expiration statuses list',
                'reconcile_extended_for_types': 'Extended Reconciliation for Types'
            },
            'description': {
                'is_falcon_long-term_synchronization_allowed': 'Allows status synchronization for more than 45 days',
                'teams_show_users': 'Show `users` column in settings-teams table',
                'teams_show_integrations': 'Show `integrations` column in settings-teams table',
                'advertisers_show_integrations_and_geo': 'Show `integrations` and `geo` columns in settings-advertisers table',
                'is_demo_data_allowed': 'Allow demo data',
                'lead_blacklist_ip': 'IP Blacklist',
                'invalid_statuses': 'Comma separated list of invalid statuses',
                'write_integration_statuses_history_log': 'Write log about synchronized lead statuses table `lead_statuses`',
                'clean_request_logs_after_days': 'Clean request logs lifetime in days',
                'clean_version_logs_after_days': 'Clean version logs lifetime in days',
                'clean_lead_logs_after_days': 'Clean lead logs lifetime in days',
                'teams_with_required_lead_ip': 'Teams with required field lead ip on lead creation',
                'thank_you_page_url_lifetime_minutes': 'Thank you page url lifetime in minutes',
                'thank_you_page_expired_url': 'Thank you page expired url',
                'lead_duplicate_check_days_prior': 'Number of days to check for duplicate leads before creation',
                'lead_duplicate_check_days_prior_for_deposit': 'Number of days to check for duplicate leads before deposit',
                'lead_expiration_status_after_days_for_falcon': 'Number of days after which a Falcon lead status is considered expired',
                'lead_expiration_status_after_days_for_non_falcon': 'Number of days after which a non-Falcon lead status is considered expired',
                'lead_expiration_status_changeable_statuses_list': 'List of lead statuses that can be changed after expiration',
                'reconcile_extended_for_types': 'Allows the use of extended reconciliation for selected data types.'
            },
        },
        notifications: {
            channels: 'Channels',
            send_to_all_channels: 'Send to all channels'
        }
    },
    ru: {
        automation: {
            parameters: 'Параметры автоматизации',
            automation_type: 'Тип автоматизации',
            start_time: 'Время запуска',
            minutes: 'Минуты',
            hours: 'Часы',
            days_of_week: 'Дни недели',
            days_of_month: 'Дни месяца',
            number_of_days: 'Количество дней',
            relative_number_of_days_in_period_start: 'Количество дней до начала периода',
            relative_number_of_days_in_period_end: 'Количество дней до конца периода',
            leads_count: 'Количество лидов',
            every_minute: 'Каждую минуту',
            hourly: 'Каждый час',
            daily: 'Каждый день',
            weekly: 'Каждую неделю',
            monthly: 'Каждый месяц',
            name: 'Название',
            start: 'Последний старт',
            end: 'Последний финиш'
        },
        loads: {
            deposits: 'Депозиты',
            overpayment: 'Переплаты',
            statuses: 'Статусы',
            statuses_count: 'Количество статусов'
        },
        sideMenu: {
            Settings_System: 'Системные настройки',
            Changes: 'Изменения',
            Logs: 'Логи',
            Home: 'Главная',
            Dashboard: 'Дашборд',
            Dashboard_Top_management: 'Топ менеджмент',
            Dashboard_Team_lead: 'Тимлид',
            Affiliate: 'Аффилейт',
            Statistic: 'Статистика',
            Statistic_Main: 'Главная',
            Statistic_Leads: 'Лиды',
            Leads: 'Лиды',
            System_health: 'Состояние системы',
            Advertiser: 'Рекламодатели',
            Falcon: 'Falcon',
            Team: 'Команда',
            Offers: 'Офферы',
            Domains: 'Домены',
            Landings: 'Лендинги',
            Settings: 'Настройки',
            Settings_Teams: 'Команды',
            Settings_Caps: 'Капы',
            Settings_Landings: 'Лендинги',
            Settings_Domains: 'Домены',
            Settings_Hold: 'Холд',
            Settings_Geo: 'Гео',
            Settings_Management: "Менеджмент",
            Users: 'Пользователи',
            Campaigns: 'Кампании',
            Check: 'Проверить',
            TestLead: 'Проверить лида',
            Faicon: 'FaIcon',
            Deposits: 'Deposits',
            Finance: 'Финансы',
            Permissions: 'Разрешения',
            Postbacks: 'Постбеки',
            Management: 'Управление',
            Cards: 'Карты',
            SMS: 'SMS',
            Messages: 'Сообщения',
            Analytics: 'Аналитика',
            Statuses: 'Статусы',
            Loads: 'Выгрузки',
            Recycle: 'Recycle',
            Deals: 'Сделки',
            Uploads: 'Загрузки',
            Moderation: 'Модерация',
            Notifications: 'Уведомления'
        },
        campaigns: {
            Approve_status: 'Статус утверждения',
            Approve: 'Утвердить',
            Standard: 'Стандарт',
            Landing_path: 'Путь лендинга',
            Platforms: 'Платформы',
            Url: 'URL',
            Tracker: 'Трекер',
            Cloaking: 'Клоакинг'
        },
        settings: {
            Stream_strength: 'Сила налива',
            In_process: 'В процесе',
            Paused: 'Paused',
            Landing_status: 'Статус лендинга',
            Clear_version: 'Clear version',
            Domain_status: 'Статус Домена',
            Offer_status: 'Статус оффера',
            Start: 'Начало',
            End: 'Конец',
            New: 'Новый',
            Old: 'Старый',
            Timing: 'Сроки'
        },
        statistic: {
            External_status: 'Внешний статус',
            CvStatistic: 'Конверсия команд',
            Traffic_by_advertiser: 'Трафик по рекламодателю',
            Traffic_by_user_team: 'Трафик по пользователю/команде',
            Traffic_by_offer: 'Трафик по офферам',
            Deposits_by_advertiser: 'Депозиты по рекламодателю',
            Deposits_by_user_team: 'Депозиты по пользователю / команде',
            Deposits_by_offer: 'Депозиты по офферам',
            Hold_by_geo: 'Холд по гео',
            Offer_domain_deps: 'Депозиты доменов по офферам',
            Top_5_affiliates: '5 лучших аффилейтов по трафику',
            Top_5_teams: '5 лучших команд по трафику',
            Top_5_offers: '5 лучших офферов по трафику',
            Person: 'Человек',
            Lang: 'Язык',
            ADV_INT: 'РЕК/ИНТ',
            SYS_Status: 'Статус системы',
            ERR_Status: 'Статус ошибки',
            ADV_Status: 'РЕК статус',
            Reg_date: 'Дата рег',
            Advertiser_status: 'Статус рекламодателя',
            Advertiser_statuses: 'Статусы рекламодателей',
            Advertiser_traffic: 'Трафик рекламодателя',
            Advertiser_traffic_by_hour: 'Advertiser traffic by hour distribution',
            Sync: 'Синх.',
            Group_Status: 'Статус группы ',
            Statuses_Statistic: 'Статистика статусов',
            Statuses_Countries: 'Статистика по странам',
            Validation_errors: 'Невалидный',
            guarantee: 'Гарантия',
            advertiser_geoconversion: 'Геоконверсия рекламодателя'
        },
        modals: {
            Edit_System_Settings: 'Изменить системные настройки',
            editSchedule: 'Изменить расписание',
            Recycle: 'Recycle leads',
            Advertiser_modal_button: 'Сохранить рекламодателя',
            Integration_modal_button: 'Сохранить интеграцию',
            Advertiser_name: 'Имя рекламодателя',
            Safe_name: 'Безопасное имя',
            Falcon_integration: 'Falcon интеграция',
            Falcon_statistic: 'Falcon статистика',
            Description: 'Описание',
            Login: 'Логин',
            URL: 'URL',
            Password: 'Пароль',
            Choose_model: 'Выберите модель',
            Choose_geo: 'Выберите гео',
            Choose_countries: 'Выберите страны',
            Choose_accepted_offers: 'Выберите принятые офферы',
            Choose_name: 'Выберите имя',
            Choose_not_accepted_offers: 'Выберите НЕ принятые офферы',
            Choose_team: 'Выберите команду',
            Choose_affiliate: 'Выберите Аффилейта',
            Choose_affiliates: 'Выберите Аффилейтов',
            Choose_offer: 'Выберите оффер',
            Choose_language: 'Выберите язык',
            Choose_landing: 'Выберите лендинг',
            Choose_prelanding: 'Выберите прелендинг',
            Choose_domain: 'Выберите домен',
            Choose_url: 'Выберите url',
            Choose_cloaking: 'Выберите клоакинг',
            Choose_postback: 'Выберите постбек',
            Choose_platform: 'Выберите платформу',
            Enter_landing_name: 'Введите название лендинга',
            Landing_name: 'Название лендинга',
            Enter_domain: 'Введите название домена',
            Domain_name: 'Название домена',
            Enter_offer_name: 'Введите название оффера',
            Offer_name: 'Название оффера',
            Enter_campaign_name: 'Введите название кампании',
            Campaign_name: 'Название кампании',
            Enter_campaign_identifier: 'Введите идентификатор кампании',
            Campaign_identifier: 'Идентификатор кампании',
            Geo_name: 'Название гео',
            Enter_geo_name: 'Введите название гео',
            Set_schedule: 'Установить расписание',
            Enter_test: 'Введите тест',
            From: 'From',
            To: 'To',
            Confirm_password: 'Подтвердить пароль',
            Team_name: 'Название команды',
            Manager_name: 'Имя менеджера',
            Self: 'Self',
            First_name: 'Имя',
            Last_name: 'Фамилия',
            Phone: 'Телефон',
            IP: 'IP',
            Preview_url: 'URL для предварительного просмотра',
            Enter_preview_url: 'Введите URL для предварительного просмотра',
            Source_url: 'Исходный URL',
            Enter_source_url: 'Ведите исходный URL',
            Companies_Removed: 'Кампании ниже будут удалены',
            Transfer_domain: 'Передать домен',
            Token: 'Токен',
            card_logs: 'Список действий по карте',
            Edit_lead: 'Редактирование лида',
            Lead_info_integration: 'Информация об интеграциях',
            Send_to_trash: 'Отправить в треш?',
            Edit_advertiser: 'Редактирование рекламодателя',
            Global_update_time: 'Глобальное обновление времени',
            Edit_integration: 'Редактировать интеграцию',
            Сopy_integration: 'Копирование интеграций',
            Edit_team: 'Редактировать команду',
            Manager_info: 'Информация о менеджере',
            Add_offer: 'Добавить оффер',
            Edit_offer: 'Редактировать оффер',
            Edit_landing: 'Редактировать лендинг',
            Edit_domain: 'Редактировать домен',
            Edit_geo: 'Редактировать гео',
            Create_module: 'Добавить модуль',
            Edit_module: 'Редактировать модуль',
            Add_permission: 'Добавить разрешения',
            Create_message: 'Добавить сообщение',
            Edit_message: 'Редактировать сообщение',
            Create_settings: 'Добавить настройки',
            Update_settings: 'Обновить настройки',
            Add_tracker: 'Добавить трекер',
            Edit_user: 'Редактировать пользователя',
            Edit_user_permission: 'Редактировать разрешения пользователя',
            Update_password: 'Обновить пароль',
            Edit_campaign: 'Редактировать кампанию',
            Edit_postback: 'Редактировать постбек',
            Postback_logs: 'Список действий постбека',
            Add_hold: 'Добавить холд',
            Edit_hold: 'Редактировать холд',
            Edit_permission: 'Редактировать разрешение',
            Lead_info: 'Информация о лиде',
            Lead_comments: 'Комментарии',
            Lead_history_statuses: 'История Статусов',
            Edit_relation: "Редактировать связь",
            Global_update_int: "Массовая замена реквизитов",
            Edit_Status: "Редактировать статус",
            CloneAdv: "Клонирование рекламодателя",
            list_relation: "Список связей",
            Hot: 'Горячий',
            Team_status: "Статус команды",
            autologin_info: "Информация об автологине",
            lead_synchronization_enable: "Включить синхронизацию лида",
            lead_synchronization_disable: "Выключить синхронизацию лида",
        },
        buttons: {
            Copy_log: 'Копировать лог',
            ForceSendLead: 'Принудительно отправить лида',
            OpenNew: 'Открыть',
            Create_integration: 'Добавить интеграцию',
            Save_integration: 'Сохранить интеграцию',
            Create_advertiser: 'Добавить рекламодателя',
            Save_advertiser: 'Сохранить рекламодателя',
            Save_campaign: 'Сохранить кампанию',
            Create_campaign: 'Добавить кампанию',
            Save_team: 'Сохранить команду',
            Create_team: 'Добавить команду',
            Create_user: 'Добавить пользователя',
            Save_user: 'Сохранить пользователя',
            Create_offer: 'Добавить оффер',
            Save_offer: 'Сохранить оффер',
            Add_integration: 'Добавить интеграцию',
            Add_landing: 'Добавить лендинг',
            Save_landing: 'Сохранить лендинг',
            Add_prelanding: 'Добавить прелендинг',
            Add_domain: 'Добавить домен',
            Save_domain: 'Сохранить домен',
            Add_geo: 'Добавить гео',
            Save_geo: 'Сохранить гео',
            Copy_link: 'Копировать ссылку',
            Show: 'Показать',
            Test: 'Тест',
            Save: 'Сохранить',
            Update: 'Обновить',
            Transfer: 'Передать',
            Add_postback: 'Добавить постбек',
            Submit: 'Отправить',
            Management: 'Управление',
            Create_card: 'Создать карту',
            Edit_card: 'Редактировать карту',
            Reset_queue: 'Сбросить очередь',
            Activate: 'Активировать',
            Deactivate: 'Деактивировать',
            Approve: 'Утвердить',
            Disapprove: 'Не утверждать',
            Add: 'Добавить',
            Delete: 'Удалить',
            Clear: 'Очистить',
            Refresh: 'Обновить',
            Show_disabled_integrations: 'Показать отключенные интеграции',
            Search: 'Поиск',
            Add_parameter: 'Добавить параметр',
            Filter: 'Фильтровать',
            Open: 'Открыть',
            Close: 'Закрыть',
            Change: 'Изменить',
            Logout: 'Выйти',
            Create_Relation: "Создать связь",
            Create_status: "Добавить статус",
            editCap: "Редактировать капу",
            saveCap: "Сохранить капу",
            generatePassword: "Сгенерировать новый пароль",
            showPassword: "Показать пароль",
            hidePassword: "Скрыть пароль",
            downloadReport: 'Скачать отчет',
            time: 'Показать расписание',
            notTime: 'Показать капы',
            sync: 'Синхронизировать',
            Decline: 'Отклонить',
            DownloadTemplate: 'Скачать шаблон'
        },
        global: {
            Conditions: 'Условия',
            MonthDay: 'День месяца',
            Hours: 'Часы',
            Minutes: 'Минуты',
            month: "Месяц",
            play: 'Запустить',
            pause: 'Пауза',
            leadSamplingParameters: "Параметры выборки лида",
            sendingOptions: "Параметры отправки",
            automation: 'Автоматизация',
            menuItem: 'Пункт меню',
            Selected: 'Выбрано',
            Entity: 'Сущность',
            Data: 'Данные',
            Method: 'Метод',
            title: 'Название',
            Straight: 'Сразу',
            uploadsLeads: 'Загрузка лидов',
            statusLeads: 'Статус лидов',
            Priority: 'Приоритет',
            land_id: 'LAND_ID',
            CapsByGeo: 'Капы по гео',
            CapsByCountry: 'Капы по странам',
            Multiple: 'Множественный выбор',
            Separator: 'Разделитель',
            globalUpdate: 'Массовое действие',
            Conversion: 'Конверсия %',
            Day: 'День',
            // Page elements
            Templates: 'Шаблоны',
            Login: 'Вход',
            Welcome: 'Добро пожаловать!',
            Filters: 'Фильтры',
            All: 'Все',
            // Table elements
            Status: 'Статус',
            System_status: 'Системные статус',
            ERROR_status: 'Статус ошибки',
            ADV_history: 'РЕК история',
            ADV_history_response: 'История ответов',
            Actions: 'Действия',
            Action: 'Действие',
            User: 'Пользователь',
            Users: 'Пользователи',
            Name: 'Имя',
            Team: 'Команда',
            Teams: 'Команды',
            Role: 'Роль',
            Roles: 'Роли',
            Role_access: 'Доступ для роли',
            Hold: 'Холд',
            Deposits: 'Депозиты',
            Depositors: 'Депозиты',
            Invalid: 'Invalid',
            CR: 'CR',
            IR: 'IR',
            Operation: 'Действие',
            // Common words
            Affiliate: 'Аффилейт',
            Offer: 'Оффер',
            Offers: 'Офферы',
            Landing: 'Лендинг',
            Landings: 'Лендинги',
            Prelanding: 'Прелендинг',
            Prelandings: 'Прелендинги',
            Advertiser: 'Рекламодатель',
            Advertisers: 'Рекламодатели',
            Geo: 'Гео',
            Model: 'Модель выплаты',
            model: 'Модель',
            Domain: 'Домен',
            Domain_leads: 'Лиды по домену',
            Integration: 'Интеграция',
            Integrations: 'Интеграции',
            Integration_Status: 'Статус интеграции',
            Integration_Parameters: 'Параметры интеграции',
            Settings_active: 'Активность настроек',
            Lead: 'Лид',
            Leads: 'Лиды',
            'Leads%': 'Лиды %',
            Date: 'Дата',
            Schedule: 'Расписание',
            Payment: 'Payment',
            Identifier: 'Идентификатор',
            Country: 'Страна',
            Countries: 'Страны',
            Language: 'Язык',
            Languages: 'Языки',
            Managers: 'Менеджеры',
            Group_statuses: 'Статусы',
            Save: 'Сохранить',
            Reset: 'Сбросить',
            Cancel: 'Отмена',
            Of: 'of',
            //
            Registration_date: 'Дата регистрации',
            Send_date: 'Дата отправки',
            Deposit_date: 'Дата депозита',
            From_hold: 'From hold',
            Synchronize: 'Синхронизация',
            Search: 'Поиск...',
            Permissions: 'Разрешения',
            Domains: 'Домены',
            Email: 'E-mail',
            Locale: 'Локация',
            Preview: 'Preview',
            Campaign: 'Кампания',
            Campaigns: 'Кампании',
            Affiliates: 'Аффилейты',
            Total: 'Все',
            Slug: 'Сокращение',
            Custom_slug: 'Пользовательское сокращение',
            Description: 'Описание',
            Event: 'Событие',
            Type: 'Тип',
            Custom: 'Пользовательский',
            Copy_url: 'Копировать ссылку',
            card: 'Карта',
            typeName: 'Название типа',
            bankName: 'Название банка',
            holderName: 'Имя держателя',
            statusName: 'Название статуса',
            platformName: 'Название платформы',
            newTypeName: 'Новое название типа',
            bank: 'Банк',
            newBankName: 'Новое название банка',
            holder: 'Держатель',
            newHolderName: 'Новое имя держателя',
            invoice: 'Счёт',
            invoiceNumber: 'Номер счета',
            newInvoiceNumber: 'Новый номер счета',
            newStatus: 'Новый статус',
            newPlatformName: 'Новое название платформы',
            code: 'Код',
            number: 'Номер карты',
            manager: 'Менеджер',
            cvv: 'CVV',
            comment: 'Коментарий',
            create: 'Создать',
            edit: 'Редактировать',
            edit_message: 'Редактировать сообщение',
            remove_message: 'Удалить сообщение',
            remove: 'Удалить',
            remove_data: 'Удалить данные',
            remove_card: 'Удалить карту?',
            owner: 'Владелец',
            link_id: 'Link ID',
            landing_url: 'Url лендинга',
            params_url: 'Параметры url',
            message: 'Сообщение',
            Start: 'Начало',
            End: 'Конец',
            Traffic_Type: 'Тип трафика',
            offer: 'Оффер',
            platform: 'Платформа',
            dateCreate: 'Дата создания',
            view: 'Вид',
            totalLeads: 'Всего лидов',
            active: 'Активные',
            inactive: 'Неактивные',
            No_data: 'Нет данных!',
            PCT: 'PCT',
            Disabled: 'Отключено',
            Time: 'Время',
            API: 'API',
            Copy: 'Скопировано!',
            Value: 'Значение',
            Default_Value: 'Значение по умолчанию',
            Information: 'Информация',
            Download: 'Скачать',
            Action_date: 'ФТД',
            TMP_Action_date: 'Tmp ФТД',
            Supplements: 'Долеты',
            Lights: 'Лайты',
            today: 'Сегодня',
            "Post deposits": 'Пост депозиты',
            response: 'Лид',
            history_response: 'Ответ рекламодателя',
            send: 'Отправлено',
            not_send: 'Не отправлено',
            Manager: 'Аффилейт менеджер',
            Endpoint: 'Ресурсы',
            Internal_status: 'Внутренний статус',
            External_status: 'Внешний статус',
            campaign_identifier: 'Идентификатор кампании',
            globalEditCaps: 'Глобальное обновление кап',
            type: 'Тип',
            guarantee: 'Гарант',
            no_guarantee: 'Без гаранта',
            id: 'ID',
            Team_ID: 'ID Команды',
            Group_status: 'Групповой статус',
            Internal: 'Внутренний',
            External: 'Внешний',
            Country_Language: 'Страна/Язык',
            byGeo: 'По гео',
            Advertiser_category: 'Категория Рекламодателя',
            Category: 'Категории',
            submitted_fields: 'Поля к отправке',
            capsByGeo: 'Капы по гео',
            capsByTeams: 'Капы по командам',
            capsByCountries: 'Капы по странам',
            capsAll: 'Общая капа',
            acceptDuplicates: 'Принимать дубли'
        },
        permissions: {
            Settings_System: 'Системные настройки',
            logs: 'Logs',
            finance_access: 'Finance',
            campaign: 'Campaigns',
            dashboard_affiliate: 'A dashboard',
            dashboard_team_leader: 'TL dashboard',
            dashboard_top_management: 'TM dashboard',
            domain: 'Domains',
            finance: 'Finance',
            landing: 'Landings',
            offer: 'Offers',
            team: 'Team',
            statistic_advertiser: 'Advertisers statistics',
            statistic_affiliate: 'Affiliate statistic',
            statistic_lead: 'Lead statistic',
            statistic_offer: 'Offer statistic',
            statistic_falcon: 'Falcon',
            user: 'Users',
            settings_advertiser: 'S Advertiser',
            settings_cap: 'S Cap',
            settings_geo: 'S Geo',
            settings_offer: 'S Offer',
            settings_team: 'S Team',
            settings_domain: 'S Domain',
            settings_landing: 'S Landing',
            settings_hold: 'S Hold',
            settings_campaign_approve: 'S Campaign approve',
            check_lead: 'Check lead',
            update_not_valid: 'Lead update',
            permission: 'Create permission',
            system_status: 'System health',
            postback: 'Postback',
            finance_cards: 'Finance Cards',
            settings_sms_messages: 'Settings sms messages',
            settings_sms_settings: 'Settings sms settings',
            finance_analytic_access: 'Financial analytics',
            settings_management: 'S management',
            settings_status_mapper: 'S status mapper',
            loads: 'Loads',
            recycle_leads: 'Recycle',
            uploads: 'Uploads',
            uploads_falcon: 'Upload falcon',
            uploads_recycle: 'Upload recycle',
            lead_upload_falcon: 'Lead upload falcon',
            settings_moderation: 'S Moderation',
            affiliate_bot: 'Affiliate notifications'
        },
        calendar: {
            Week: 'Неделя',
            daysOfWeek: {
                Sunday: 'Воскресенье',
                Monday: 'Понедельник',
                Tuesday: 'Вторник',
                Wednesday: 'Среда',
                Thursday: 'Четверг',
                Friday: 'Пятница',
                Saturday: 'Суббота'
            },
            daysOfWeek_short: {
                Sun: 'Вс',
                Mon: 'Пн',
                Tue: 'Вт',
                Wed: 'Ср',
                Thu: 'Чт',
                Fri: 'Пт',
                Sat: 'Сб'
            },
            weekdaysMin: {
                Su: 'Вс',
                Mo: 'Пн',
                Tu: 'Вт',
                We: 'Ср',
                Th: 'Чт',
                Fr: 'Пт',
                Sa: 'Сб'
            },
            monthNames_short: {
                Jan: 'Январь',
                Feb: 'Февраль',
                Mar: 'Март',
                Apr: 'Апрель',
                May: 'Май',
                Jun: 'Июнь',
                Jul: 'Июль',
                Aug: 'Август',
                Sep: 'Сентябрь',
                Oct: 'Октябрь',
                Nov: 'Ноябрь',
                Dec: 'Декабрь'
            },
            sidebar: {
                today: 'Cегодня',
                yesterday: 'Вчера',
                this_month: 'Этот месяц',
                last_month: 'Прошлый месяц',
                this_year: 'За год'
            },
            Apply: 'Применить',
            Cancel: 'Отмена'
        },
        system_health: {
            without_advertiser_status: 'Отправленные без статуса',
            without_group_status: 'Отправленные без гр. статуса',
            not_valid: 'Невалидные',
            without_internal_price: 'Без внутренней цены',
            without_external_price: 'Без внешней цены',
            fa_date_without_gstatus: 'С датой депозита, без статуса',
            gstatus_without_fa_date: 'Со статусом, без даты депозита',
            multiple_success_send: 'Повторная отправка'
        },
        error: {
            duplicate_country_and_lenguage_in_geo: 'Cтрана {country} с языком {language} выбрана в гео - {geo}',
            no_changed_new_owner_or_platform: 'Владелец или платформа должны отличаться от текущих',
            messageErrorDomain: 'Неверное имя домена',
            messageDuplicateDomain: 'Повторяющееся имя домена'
        },
        statistic_fields: {
            geo: 'Гео',
            send: 'Отправить',
            sub1: 'Саб1',
            sub2: 'Саб2',
            sub3: 'Саб3',
            sub4: 'Саб4',
            sub5: 'Саб5',
            sub6: 'Саб6',
            sub7: 'Саб7',
            sub8: 'Саб8',
            sub9: 'Саб9',
            offer: 'Оффер',
            domain: 'Домен',
            status: 'Статис',
            actions: 'Действие',
            country: 'Страна',
            landing: 'Лендинг',
            a_status: 'Рек_статус',
            language: 'Язык',
            personal: 'Лид',
            s_status: 'Cис_статус',
            affiliate: 'Аффилейт',
            advertiser: 'Рекламодатель',
            adv_history: 'Рек_история',
            registration: 'Регистрация',
            sms: 'СМС',
            id: 'ID',
            lead_id: 'Lead ID'
        },
        card_statuses: {
            new: 'Новая',
            active: 'Активная',
            inactive: 'Неактивная',
            closed: 'Закрытая',
            unknown: 'Неизвестный статус'
        },
        table: {
            No_data_available: 'Нет данных!',
            AVG_Price: 'Средняя цена',
            CR: 'CR%',
            sendedLeads: 'Отправленные',
            duplicateLeads: 'Дубликаты',
            trash: 'Tреш',
            team_ID: 'ID команды',
            Traffic_model: 'Модель выплаты',
            Is_internal: 'Внутренний',
            Is_internal_team: 'Внутренняя',
            Global_status: 'Глобальный статус',
            Global_actions: 'Глобальные действия',
            Total_cap: 'Все капы',
            Campaign_ID: 'ID кампании',
            Ex_price: 'Ex. price',
            Int_price: 'Int. price',
            Internal_price_summ: 'Внутренняя сумма',
            External_price_summ: 'Внешняя сумма',
            isHot: 'Горячий трафик',
            autologin: 'Автологин'
        },
        tooltip: {
            allStatuses: 'По всем статусам',
            Download_CSV: 'Скачать в CSV',
            Watch_full_stats: 'Посмотреть полную статистику',
            Copy: 'Скопировать',
            Copy_password: 'Скопировать пароль',
            Show: 'Показать',
            Hide: 'Скрыть',
            Reset_filter: 'Сбросить фильтр',
            Refresh_table: 'Обновить таблицу',
            Delete_integration: 'Удалить интеграцию',
            Stop_traffic: 'Остановить трафик',
            Start_traffic: 'Запустить трафик',
            Update_traffic: 'Обновить трафик',
            Add_country_and_language: 'Добавить страну и язык',
            Delete_country_and_language: 'Удалить страну и язык',
            Active_card: 'Активировать карту',
            Deactive_card: 'Деактивировать карту',
            Change_owner_or_platform: 'Изменить владельца или платформу',
            Close_card: 'Закрыть карту',
            Login_as_this_user: 'Войти под этим пользователем',
            Download_list_domains: 'Скачать список доменов',
            Temporary_depositor: 'Временный депозитор',
            Comment: 'Комментарий',
            add_param: 'Добавить параметр',
            delete_param: 'Удалить параметр',
            delete_advertiser: 'Удалить рекламодателя',
            Group_by_advertiser: 'Группировать по рекламодателям',
            Undo_grouping: 'Отменить группировку',
            Delete: 'Удалить',
            detailsTeam: 'Список команд',
            detailsAdvertisers: 'Список рекламодателей',
            toTrash: 'Отправить в треш',
            clearErrors: 'Очистить ошибки',
            cold_traffic: 'Низкий приоритет',
            edit_time: 'Редактировать время',
            updateStatus: 'Обновить РЕК статус',
            scheduling_caps: "Расписание кап",
            set_caps: "Значение кап",
            statusPart: "Есть сделки с низким приоритетом",
            statusAll: "Все сделки с низким приоритетом",
            statusNone: "Нет сделок с низким приоритетом",
            lowPriority: "Низкий приоритет",
            highPriority: "Высокий приоритет",
            view: 'Просмотреть',
            upload: 'Загрузить',
            remove: 'Удалить',
            Resend: 'Переотправить',
            reindexing: 'Переиндексация'
        },
        confirm: {
            removeAutomation: 'Вы собираетесь удалить автоматизацию!',
            deactivateStatus: 'Вы собираетесь ДЕАКТИВИРОВАТЬ системный статус!',
            activateStatus: 'Вы собираетесь АКТИВИРОВАТЬ системный статус!',
            Confirm_action: 'Подтвердить действие',
            activateAdvertiser: 'Вы собираетесь АКТИВИРОВАТЬ рекламодателя!',
            deactivateAdvertiser: 'Вы собираетесь ДЕАКТИВИРОВАТЬ рекламодателя!',
            activateIntegration: 'Вы собираетесь АКТИВИРОВАТЬ интеграцию!',
            deactivateIntegration: 'Вы собираетесь ДЕАКТИВИРОВАТЬ интеграцию!',
            deleteIntegration: 'Вы собираетесь УДАЛИТЬ интеграцию!',
            clearQueue: 'Вы уверены, что хотите очистить очередь?',
            refreshTraffic: 'Обновить трафик в этой интеграции?',
            stopTrafficOnIntegration: 'ОСТАНОВИТЬ трафик в этой интеграции?',
            startTrafficOnIntegration: 'Запустить трафик в этой интеграции?',
            btnStopTrafficOnIntegration: 'Остановить',
            btnStartTrafficOnIntegration: 'Запустить',
            deactivateOffer: 'Вы собираетесь ДЕАКТИВИРОВАТЬ oффер!',
            activateOffer: 'Вы собираетесь АКТИВИРОВАТЬ oффер!',
            deactivateLanding: 'Вы собираетесь ДЕАКТИВИРОВАТЬ лендинг!',
            activateLanding: 'Вы собираетесь АКТИВИРОВАТЬ лендинг!',
            deactivateDomain: 'Вы собираетесь ДЕАКТИВИРОВАТЬ домен!',
            activateDomain: 'Вы собираетесь АКТИВИРОВАТЬ домен!',
            deleteMessage: 'Вы уверены, что хотите удалить этo сообщение?',
            deleteMessageSettings: 'Вы уверены, что хотите удалить эту настройку?',
            deactivateUser: 'Вы собираетесь ДЕАКТИВИРОВАТЬ пользователя!',
            activateUser: 'Вы собираетесь АКТИВИРОВАТЬ пользователя!',
            activatePostback: 'Вы собираетесь АКТИВИРОВАТЬ постбек!',
            deactivatePostback: 'Вы собираетесь ДЕАКТИВИРОВАТЬ постбек!',
            deactivateСampaign: 'Вы собираетесь ДЕАКТИВИРОВАТЬ кампанию!',
            activateСampaign: 'Вы собираетесь АКТИВИРОВАТЬ кампанию!',
            disapproveСampaign: 'Вы хотите НЕ УТВЕРЖДАТЬ кампанию!',
            approveСampaign: 'Вы собираетесь УТВЕРДИТЬ кампанию!',
            deactivateСard: 'Вы уверены, что хотите ДЕАКТИВИРОВАТЬ карту?',
            activateСard: 'Вы уверены, что хотите АКТИВИРОВАТЬ карту?',
            deactivateHold: 'Вы собираетесь ДЕАКТИВИРОВАТЬ холд!',
            activateHold: 'Вы собираетесь АКТИВИРОВАТЬ холд!',
            closeCard: 'Вы уверены, что хотите ЗАКРЫТЬ карту?',
            openCard: 'Вы уверены, что хотите ОТКРЫТЬ карту?',
            changeOwnerOrPlatform: 'Вы собираетесь изменить менеджера или платформу!',
            deactivateTeam: 'Вы собираетесь ДЕАКТИВИРОВАТЬ команду!',
            activateTeam: 'Вы собираетесь АКТИВИРОВАТЬ команду!',
            destroyAdvertiser: 'Вы уверены, что хотите УДАЛИТЬ рекламодателя?',
            clearErrors: 'Вы уверены, что хотите ОЧИСТИТЬ ошибки?',
            removeLeads: 'Вы уверены что хотите удалить все лиды?',
            confirm: 'Подтвердить'
        },
        label: {
            Sync_available: 'Синхронизация',
            Only_hot_trafic: 'Только горячий трафик',
            team_status: 'Активная',
            Choose_advertiser: 'Выберите рекламодателя',
            Choose_integration: 'Выберите интеграцию',
            External_price: 'Внешняя цена',
            Internal_price: 'Внутренняя цена',
            percent: 'Процент',
            guarantee: 'Гарантия',
            new_path: 'Новый путь',
            Free_domains: 'Свободные домены',
            Event_type: 'Тип события',
            Parameter_name: 'Название параметра',
            Postbacks: 'Постбеки',
            Advertisers_history: 'История рекламодателей',
            Unvalid: 'Невалидный/%',
            Valid: 'Валидный',
            Summ: 'Сумма',
            changeParameter: 'Изменить параметр',
            enterKey: 'Введите ключ',
            enterValue: 'Введите значение',
        },
        page_404: {
            Title: '404 Страница не найдена!',
            Back_previous: 'Вернуться на предыдущую страницу',
            Back_home: 'Вернуться на главную'
        },
        not_authorized: {
            Title: 'Вы не авторизованы!'
        },
        table_filters: {
            sub: 'Саб',
            advertisers: 'Pекламодатель',
            advertisers_categories: 'Категория Рекламодателя',
            affiliates: 'Аффилейт',
            countries: 'Страна',
            external_price: 'Внешняя цена',
            geos: 'Гео',
            geo: 'Гео',
            integrations: 'Интеграция',
            internal_price: 'Внутренняя цена',
            statuses: 'Статус',
            traffic_models: 'Модель выплаты',
            advertiser_id: 'Рекламодатель',
            domains: 'Домен',
            advertiser_integration_id: 'Интеграция',
            traffic_model_id: 'Модель выплаты',
            team_id: 'Команда',
            teams: 'Команда',
            affiliate_hash: 'Аффилейт',
            group_statuses: 'Статус',
            language: 'Язык',
            country: 'Страна',
            offer_name: 'Оффер',
            offers: 'Оффер',
            landing_name: 'Лендинг',
            group_status: 'Статус',
            team_name: 'Команда',
            role_name: 'Роль',
            active_name: 'Статус',
            affiliate_id: 'Аффилейт',
            advertiser_integration: 'Интеграция',
            affiliate_name: 'Аффилейт',
            domain: 'Домен',
            affiliate: 'Аффилейт',
            offer: 'Оффер',
            languages: 'Язык',
            approve: 'Утвердить',
            status: 'Статус',
            manager_id: "Аффилейт менеджер",
            guarantee: 'Гарантия',
            advertiser_categories: 'Категория Рекламодателя',
            pay_out: 'Pay out',
            email: 'Email',
            first_name: 'Имя',
            last_name: 'Фамилия',
            lead_id: 'Lead id',
            lead_status: 'Статус',
            phone: 'Телефон',
            currency: 'Валюта',
            manager: 'Менеджер'
        },
        server_filter: {
            advertisers: 'Pекламодатель',
            integrations: 'Интеграция',
            traffic_models: 'Модель выплаты',
            affiliate_id: 'Аффилейт',
            affiliates: 'Аффилейт',
            geos: 'Гео',
            teams: 'Команда',
            offers: 'Оффер',
            domains: 'Домен',
            advertiser_integration: 'Интеграция',
            countries: "Страна",
            status: 'Статус',
            approve: 'Утвердить',
            language: 'Язык',
            languages: 'Язык',
            affiliate: 'Аффилейт',
            offer: 'Оффер',
            domain: 'Домен',
            all: 'Все',
            is_active: "Статус",
            is_approved: "Утвердить"
        },
        validationErrors: {
            unique: 'Значение должно быть уникальным',
            floatOrInteger: 'Поле {name} не является корректным',
            integer: 'Поле {name} должно быть целым числом',
            required: 'Поле {name} является обязательным',
            minmax: 'Минимально {minimum}, максимально {maximum}',
            max_value: 'Максимальное значение: {max}',
            min: 'Минимальное значение: {min}',
            max: 'Максимально значение: {max}',
            email: 'Некорректный email адрес',
            is_not: 'Значение недействительно',
            confirmed: '{target} не совпадает',
            ip: 'Некорректный IP адрес',
            numeric: 'Поле {name} является числовым',
            negativeNumber: 'Поле {name} не может быть отрицательным числом',
            url: 'Некорректный Url адрес',
            incorrect_value: 'Неверное значение',
            incorrect_card_number: 'Некорректный номер карты',
            incorrect_cvv: 'Некорректный CVV',
            errorAddTitle: 'Домены не добавлены',
            string: 'Поле {name} Должно быть строкой',
            incorrect_phone_number: 'Неверный номер телефона',
            maxNum: 'Превышено максимальное значение в {target}',
            minNum: 'Минимальное значение не может быть меньше {target}',
            gte: 'Значение должно быть больше или равно полю: {targetName}'
        },
        bgErrors: {
            different: 'Поле должно быть уникальным',
            unique: 'Поле должно быть уникальным',
            integer: 'Поле должно быть целым числом',
            required: 'Поле должно быть заполнено',
            max: 'Превышен максимальный лимит',
            regex: 'Неверный формат',
            uniqueDomain: 'Такой домен уже существует',
            unknown: 'Неизвестная ошибка'
        },
        notification: {
            error: 'Ошибка',
            success: 'Скопировано!',
            errorMessage: 'Что-то пошло не так!'
        },
        leadCount: {
            'sended': 'Отправленные',
            'hold': 'Холд',
            'not_valid': 'Невалидные',
            'trash': 'Tреш',
            'duplicate': 'Дубликаты',
            'double': 'Дубликаты',
            'leads': 'Отправленные',
            'pending': 'В переотправке',
            'sent': 'Переотправленные',
            'failed': 'Ошибка отправки',
            'sended_false': 'Отклоненные',
        },
        date: {
            send_date: "По дате отправки",
            created_at: "По дате регистрации",
            first_action_date: "По дате депозита"
        },
        tab: {
            internal_response: 'Внутренний ответ',
            external_response: 'Внешний ответ',
            lead_test: 'Тест лида',
            sync_status: 'Тест синхронизации'
        },
        upload: {
            title: 'Перетащите или выберите необходимый файл.',
            size: 'Размер файла не должен превышать {size} МБ.',
            notValidFields: 'CSV имеет невалидные поля!',
            notValidUniqueFields: 'CSV имеет повторяющиеся поля!'
        },
        system_settings: {
            'category': {
                thank_you_page: 'Thank you page',
                settings_teams: 'Настройки -> команды',
                settings_advertisers: 'Настройки -> рекламодатели',
                logs: 'Логи',
                lead_acceptance: 'Приемка лида',
                global: 'Глобальные',
                finance_analytics: 'Финансы аналитика'
            },
            'title': {
                'is_falcon_long-term_synchronization_allowed': 'Долгосрочная синхронизация статуса Falcon',
                'is_demo_data_allowed': 'Разрешены ли демонстрационные данные?',
                'lead_blacklist_ip': 'Черный список IP-адресов',
                'invalid_statuses': 'Недействительные статусы',
                'write_integration_statuses_history_log': 'Писать лог по синхронизированным статусам таблица `lead_statuses`',
                'clean_request_logs_after_days': 'Время жизни request logs',
                'clean_version_logs_after_days': 'Время жизни  version logs',
                'clean_lead_logs_after_days': 'Время жизни lead logs',
                'teams_with_required_lead_ip': 'Команды с обязательным полем ип лида при создании лида',
                'thank_you_page_expired_url': 'Thank you page expired url',
                'thank_you_page_url_lifetime_minutes': 'Время жизни thank you page',
                'teams_show_users': 'Показать пользователей',
                'teams_show_integrations': 'Показать интеграции',
                'advertisers_show_integrations_and_geo': 'Показать интеграции и гео',
                'lead_duplicate_check_days_prior': 'Период проверки дубликатов лида (в днях)',
                'lead_duplicate_check_days_prior_for_deposit': 'Период проверки дубликатов лида для депозитов (в днях)',
                'lead_expiration_status_after_days_for_falcon': 'Срок истечения лида (в днях) для Falcon',
                'lead_expiration_status_after_days_for_non_falcon': 'Срок истечения лида (в днях) для non-Falcon',
                'lead_expiration_status_changeable_statuses_list': 'Список изменяемых статусов истечения лида',
                'reconcile_extended_for_types': 'Расширенная сверка для типов'
            },
            'description': {
                'is_falcon_long-term_synchronization_allowed': 'Позволяет синхронизировать статус более 45 дней',
                'teams_show_users': 'Показывать колонку `users` в таблице',
                'teams_show_integrations':  'Показывать колонку `integrations` в таблице',
                'advertisers_show_integrations_and_geo': 'Показывать колонки `integrations` и `geo`в таблице',
                'is_demo_data_allowed': 'Разрешить демо данные',
                'lead_blacklist_ip': 'Черный список IP-адресов',
                'invalid_statuses': 'Список недопустимых статусов, разделенных запятыми',
                'write_integration_statuses_history_log': 'Писать лог по синхронизированным статусам',
                'clean_request_logs_after_days': 'Время жизни request logs в днях',
                'clean_version_logs_after_days': 'Время жизни version logs в днях',
                'clean_lead_logs_after_days': 'Время жизни lead logs в днях',
                'teams_with_required_lead_ip': 'Команды с обязательным полем ип лида при создании лида',
                'thank_you_page_url_lifetime_minutes': 'Время жизни thank you page url в минутах',
                'thank_you_page_expired_url': 'Thank you page expired url',
                'lead_duplicate_check_days_prior': 'Количество дней для проверки дубликатов лида перед созданием',
                'lead_duplicate_check_days_prior_for_deposit': 'Количество дней для проверки дубликатов лида перед депозитом',
                'lead_expiration_status_after_days_for_falcon': 'Количество дней, после которых статус лида Falcon считается истекшим',
                'lead_expiration_status_after_days_for_non_falcon': 'Количество дней, после которых статус лида non-Falcon считается истекшим',
                'lead_expiration_status_changeable_statuses_list': 'Список статусов лида, которые можно изменять после истечения срока',
                'reconcile_extended_for_types': 'Позволяет использовать расширенную сверку для выбранных типов данных.'
            },
        },
        notifications: {
            channels: 'Каналы',
            send_to_all_channels: 'Отправить во все каналы'
        }
    },
    ua: {
        automation: {
            parameters: 'Параметри автоматизації',
            automation_type: 'Тип автоматизації',
            start_time: 'Час виконання',
            minutes: 'Хвилини',
            hours: 'Години',
            days_of_week: 'Дні тиждня',
            days_of_month: 'Дні місяця',
            number_of_days: 'Кількість днів',
            relative_number_of_days_in_period_start: 'Кількість днів до початку періоду',
            relative_number_of_days_in_period_end: 'Кількість днів до кінця періоду',
            leads_count: 'Кількість лідів',
            every_minute: 'Кожну хвилину',
            hourly: 'Кожну годину',
            daily: 'Кожен день',
            weekly: 'Кожен тиждень',
            monthly: 'Кожен місяць',
            name: 'Назва',
            start: 'Останній старт',
            end: 'Останній фініш'
        },
        loads: {
            deposits: 'Депозити',
            overpayment: 'Переплати',
            statuses: 'Статуси',
            statuses_count: 'Кількість статусів'
        },
        sideMenu: {
            Settings_System: 'Системнi налаштування',
            Changes: 'Зміни',
            Logs: 'Логи',
            Home: 'Головна',
            Dashboard: 'Дашборд',
            Dashboard_Top_management: 'Топ менеджмент',
            Dashboard_Team_lead: 'Тімлід',
            Affiliate: 'Аффілейт',
            Statistic: 'Статистика',
            Statistic_Main: 'Головна',
            Statistic_Leads: 'Ліди',
            Leads: 'Ліди',
            System_health: 'Стан системи',
            Advertiser: 'Рекламодавці',
            Falcon: 'Falcon',
            Team: 'Команда',
            Offers: 'Оффери',
            Domains: 'Домени',
            Landings: 'Лендінги',
            Settings: 'Налаштування',
            Settings_Teams: 'Команди',
            Settings_Caps: 'Капи',
            Settings_Landings: 'Лендінги',
            Settings_Domains: 'Домени',
            Settings_Hold: 'Холд',
            Settings_Geo: 'Гео',
            Settings_Management: "Менеджмент",
            Users: 'Користувачі',
            Campaigns: 'Кампанії',
            Check: 'Перевірити',
            TestLead: 'Перевірити ліда',
            Faicon: 'FaIcon',
            Deposits: 'Deposits',
            Finance: 'Фінанси',
            Permissions: 'Дозволи',
            Postbacks: 'Постбеки',
            Management: 'Управління',
            Cards: 'Карти',
            SMS: 'SMS',
            Messages: 'Повідомлення',
            Analytics: 'Аналітика',
            Statuses: 'Статуси',
            Loads: 'Вивантаження',
            Recycle: 'Recycle',
            Deals: 'Угоди',
            Uploads: 'Завантаження',
            Moderation: 'Модерація',
            Notifications: 'Сповіщення'
        },
        campaigns: {
            Approve_status: 'Статус затвердження',
            Approve: 'Затвердити',
            Standard: 'Стандарт',
            Landing_path: 'Шлях лендінгу',
            Platforms: 'Платформи',
            Url: 'URL',
            Tracker: 'Трекер',
            Cloaking: 'Клоакінг'
        },
        settings: {
            Stream_strength: 'Сила наливу',
            In_process: 'В процесі',
            Paused: 'Paused',
            Landing_status: 'Статус лендінгу',
            Clear_version: 'Clear version',
            Domain_status: 'Статус Домена',
            Offer_status: 'Статус офферу',
            Start: 'Початок',
            End: 'Кінець',
            New: 'Новий',
            Old: 'Старий',
            Timing: 'Терміни'
        },
        statistic: {
            External_status: 'Зовнішній статус',
            CvStatistic: 'Конверсія команд',
            Traffic_by_advertiser: 'Трафік з рекламодавця',
            Traffic_by_user_team: 'Трафік по користувачеві/команді',
            Traffic_by_offer: 'Трафік офферами',
            Deposits_by_advertiser: 'Депозити з рекламодавця',
            Deposits_by_user_team: 'Депозити за користувачем / командою',
            Deposits_by_offer: 'Депозити з офферів',
            Hold_by_geo: 'Холд з гео',
            Offer_domain_deps: 'Депозити доменів з офферів',
            Top_5_affiliates: '5 найкращих аффілейтів з трафіку',
            Top_5_teams: '5 найкращих команд з трафіку',
            Top_5_offers: '5 кращих офферів з трафіку',
            Person: 'Людина',
            Lang: 'Мова',
            ADV_INT: 'РЕК/ІНТ',
            SYS_Status: 'Статус системи',
            ERR_Status: 'Статус помилки',
            ADV_Status: 'РЕК статус',
            Reg_date: 'Дата рег',
            Advertiser_status: 'Статус рекламодавця',
            Advertiser_statuses: 'Статуси рекламодавців',
            Advertiser_traffic: 'Трафік рекламодавця',
            Advertiser_traffic_by_hour: 'Advertiser traffic by hour distribution',
            Sync: 'Сінх.',
            Group_Status: 'Статус групи ',
            Statuses_Statistic: 'Статистика статусів',
            Statuses_Countries: 'Статистика по країнах',
            Validation_errors: 'Невалідний',
            guarantee: 'Гарантія',
            advertiser_geoconversion: 'Геоконверсія рекламодавця'
        },
        modals: {
            Edit_System_Settings: 'Змінити системнi налаштування',
            editSchedule: 'Змінити розклад',
            Recycle: 'Recycle leads',
            Advertiser_modal_button: 'Зберегти рекламодавця',
            Integration_modal_button: 'Зберегти інтеграцію',
            Advertiser_name: 'Ім\'я рекламодавця',
            Safe_name: 'Безпечне ім\'я',
            Falcon_integration: 'Falcon інтеграція',
            Falcon_statistic: 'Falcon статистика',
            Description: 'Опис',
            Login: 'Логін',
            URL: 'URL',
            Password: 'Пароль',
            Choose_model: 'Виберіть модель',
            Choose_geo: 'Виберіть гео',
            Choose_countries: 'Виберіть країни',
            Choose_accepted_offers: 'Виберіть прийняті оффери',
            Choose_name: 'Виберіть ім\'я',
            Choose_not_accepted_offers: 'Виберіть НЕ прийняті оффери',
            Choose_team: 'Виберіть команду',
            Choose_affiliate: 'Виберіть Аффілейту',
            Choose_affiliates: 'Виберіть Аффілейтів',
            Choose_offer: 'Виберіть оффер',
            Choose_language: 'Виберіть мову',
            Choose_landing: 'Виберіть лендінг',
            Choose_prelanding: 'Виберіть прелендінг',
            Choose_domain: 'Виберіть домен',
            Choose_url: 'Виберіть URL',
            Choose_cloaking: 'Виберіть клоакінг',
            Choose_postback: 'Виберіть постбек',
            Choose_platform: 'Виберіть платформу',
            Enter_landing_name: 'Введіть назву лендінгу',
            Landing_name: 'Назва лендінгу',
            Enter_domain: 'Введіть назву домену',
            Domain_name: 'Назва домену',
            Enter_offer_name: 'Введіть назву офферу',
            Offer_name: 'Назва офферу',
            Enter_campaign_name: 'Введіть назву кампанії',
            Campaign_name: 'Назва кампанії',
            Enter_campaign_identifier: 'Введіть ідентифікатор кампанії',
            Campaign_identifier: 'Ідентифікатор кампанії',
            Geo_name: 'Назва гео',
            Enter_geo_name: 'Введіть назву гео',
            Set_schedule: 'Встановити розклад',
            Enter_test: 'Введіть тест',
            From: 'From',
            To: 'To',
            Confirm_password: 'Підтвердити пароль',
            Team_name: 'Назва команди',
            Manager_name: 'Ім\'я менеджера',
            Self: 'Self',
            First_name: 'Ім\'я',
            Last_name: 'Прізвище',
            Phone: 'Телефон',
            IP: 'IP',
            Preview_url: 'URL для попереднього перегляду',
            Enter_preview_url: 'Введіть URL для попереднього перегляду',
            Source_url: 'Початковий URL',
            Enter_source_url: 'Ведіть вихідну URL-адресу',
            Companies_Removed: 'Кампании ниже будут удалены',
            Transfer_domain: 'Передати домен',
            Token: 'Токен',
            card_logs: 'Список дій по карті',
            Edit_lead: 'Редагування ліда',
            Lead_info_integration: 'Інформація про інтеграцію',
            Send_to_trash: 'Відправити у треш?',
            Edit_advertiser: 'Редагування рекламодавця',
            Global_update_time: 'Глобальне оновлення часу',
            Edit_integration: 'Редагувати інтеграцію',
            Сopy_integration: 'Копіювання інтеграцій',
            Edit_team: 'Редагувати команду',
            Manager_info: 'Інформація про менеджера',
            Add_offer: 'Додати оффер',
            Edit_offer: 'Редагувати оффер',
            Edit_landing: 'Редагувати лендинг',
            Edit_domain: 'Редагувати домен',
            Edit_geo: 'Редагувати гео',
            Create_module: 'Додати модуль',
            Edit_module: 'Редагувати модуль',
            Add_permission: 'Додати дозволи',
            Create_message: 'Додати повідомлення',
            Edit_message: 'Редагувати повідомлення',
            Create_settings: 'Додати налаштування',
            Update_settings: 'Обновить настройки',
            Add_tracker: 'Додати трекер',
            Edit_user: 'Редагувати користувача',
            Edit_user_permission: 'Редагувати дозволи користувача',
            Update_password: 'Оновити пароль',
            Edit_campaign: 'Редагувати кампанію',
            Edit_postback: 'Редагувати постбек',
            Postback_logs: 'Список дій постбеку',
            Add_hold: 'Додати холд',
            Edit_hold: 'Редагувати холд',
            Edit_permission: 'Редагувати дозвіл',
            Lead_info: 'Інформація про лід',
            Lead_comments: 'Коментарі',
            Lead_history_statuses: 'История Статусов',
            Edit_relation: "Редагувати зв'язок",
            Global_update_int: "Масова заміна реквізитів",
            Edit_Status: "Редагувати статус",
            CloneAdv: "Клонування рекламодавця",
            list_relation: "Список зв'язків",
            Hot: 'Гарячий',
            Team_status: "Статус команди",
            autologin_info: "Інформація про автологін",
            lead_synchronization_enable: "Ввімкнути синхронізацію ліда",
            lead_synchronization_disable: "Вимкнути синхронізацію ліда"
        },
        buttons: {
            Copy_log: 'Копіювати лог',
            ForceSendLead: 'Примусово відправити ліда',
            OpenNew: 'Відкрити',
            Create_integration: 'Додати інтеграцію',
            Save_integration: 'Зберегти інтеграцію',
            Create_advertiser: 'Додати рекламодавця',
            Save_advertiser: 'Зберегти рекламодавця',
            Save_campaign: 'Зберегти кампанію',
            Create_campaign: 'Додати кампанію',
            Save_team: 'Зберегти команду',
            Create_team: 'Додати команду',
            Create_user: 'Додати користувача',
            Save_user: 'Зберегти користувача',
            Create_offer: 'Додати оффер',
            Save_offer: 'Зберегти оффер',
            Add_integration: 'Додати інтеграцію',
            Add_landing: 'Додати лендінг',
            Save_landing: 'Додати лендінг',
            Add_prelanding: 'Додати прелендінг',
            Add_domain: 'Додати домен',
            Save_domain: 'Зберегти домен',
            Add_geo: 'Додати гео',
            Save_geo: 'Зберегти гео',
            Copy_link: 'Копіювати посилання',
            Show: 'Показати',
            Test: 'Тест',
            Save: 'Зберегти',
            Update: 'Оновити',
            Transfer: 'Передати',
            Add_postback: 'Додати постбек',
            Submit: 'Відправити',
            Management: 'Управління',
            Create_card: 'Створити картку',
            Edit_card: 'Редагувати картку',
            Reset_queue: 'Скинути чергу',
            Activate: 'Активувати',
            Deactivate: 'Деактивувати',
            Approve: 'Затвердити',
            Disapprove: 'Не стверджувати',
            Add: 'Додати',
            Delete: 'Видалити',
            Clear: 'Очистити',
            Refresh: 'Оновити',
            Show_disabled_integrations: 'Показати вимкнені інтеграції',
            Search: 'Пошук',
            Add_parameter: 'Додати параметр',
            Filter: 'Фільтрувати',
            Open: 'Відкрити',
            Close: 'Закрити',
            Change: 'Змінити',
            Logout: 'Вийти',
            Create_Relation: "Створити зв'язок",
            Create_status: "Додати статус",
            editCap: "Редагувати капу",
            saveCap: "Зберегти капу",
            generatePassword: "Згенерувати новий пароль",
            showPassword: "Показать пароль",
            hidePassword: "Приховати пароль",
            downloadReport: 'Завантажити звіт',
            time: 'Показати розклад',
            notTime: 'Показати капи',
            sync: 'Синхронізувати',
            Decline: 'Відхилити',
            DownloadTemplate: 'Завантажити шаблон'
        },
        global: {
            Conditions: 'Умови',
            MonthDay: 'День місяця',
            Hours: 'Години',
            Minutes: 'Хвилини',
            month: "Місяць",
            play: 'Запустити',
            pause: 'Пауза',
            leadSamplingParameters: "Параметри вибірки ліда",
            sendingOptions: "Параметри відправлення",
            automation: 'Автоматизація',
            menuItem: 'Пункт меню',
            Selected: 'Вибране',
            Entity: 'Сутність',
            Data: 'Дані',
            Method: 'Метод',
            title: 'Назва',
            Straight: 'Відразу',
            uploadsLeads: 'Завантаження лідів',
            statusLeads: 'Статус лідів',
            Priority: 'Пріоритет',
            land_id: 'LAND_ID',
            CapsByGeo: 'Капи по гео',
            CapsByCountry: 'Капи по країнам',
            Multiple: 'Мульти вибір',
            Separator: 'Сепоратор',
            globalUpdate: 'Масова дія',
            Conversion: 'Конверсія %',
            Day: 'День',
            Templates: 'Шаблони',
            Login: 'Вхід',
            Welcome: 'Ласкаво просимо!',
            Filters: 'Фільтри',
            All: 'Усе',
            Status: 'Статус',
            System_status: 'Системний статус',
            ERROR_status: 'Статус помилки',
            ADV_history: 'РЕК історія',
            ADV_history_response: 'Історія відповідей',
            Actions: 'Дії',
            Action: 'Дія',
            User: 'Користувач',
            Users: 'Користувачі',
            Name: 'Ім\'я',
            Team: 'Команда',
            Teams: 'Команди',
            Role: 'Роль',
            Roles: 'Ролі',
            Role_access: 'Доступ до ролі',
            Hold: 'Холд',
            Deposits: 'Депозити',
            Depositors: 'Депозити',
            Invalid: 'Invalid',
            CR: 'CR',
            IR: 'IR',
            Operation: 'Дія',
            Affiliate: 'Аффілейт',
            Offer: 'Оффер',
            Offers: 'Оффери',
            Landing: 'Лендінг',
            Landings: 'Лендінги',
            Prelanding: 'Прелендінг',
            Prelandings: 'Прелендінги',
            Advertiser: 'Рекламодавець',
            Advertisers: 'Рекламодавці',
            Geo: 'Гео',
            Model: 'Модель виплати',
            model: 'Модель',
            Domain: 'Домен',
            Domain_leads: 'Ліди по домену',
            Integration: 'Інтеграція',
            Integrations: 'Інтеграції',
            Integration_Status: 'Статус інтеграції',
            Integration_Parameters: 'Параметри інтеграції',
            Settings_active: 'Активність налаштувань',
            Lead: 'Лід',
            Leads: 'Ліди',
            'Leads%': 'Ліди %',
            Date: 'Дата',
            Schedule: 'Розклад',
            Payment: 'Payment',
            Identifier: 'Ідентифікатор',
            Country: 'Країна',
            Countries: 'Країни',
            Language: 'Мова',
            Languages: 'Мови',
            Managers: 'Менеджери',
            Group_statuses: 'Статуси',
            Save: 'Зберегти',
            Reset: 'Скинути',
            Cancel: 'Відміна',
            Of: 'of',
            Registration_date: 'Дата реєстрації',
            Send_date: 'Дата відправки',
            Deposit_date: 'Дата депозита',
            From_hold: 'From hold',
            Synchronize: 'Синхронізація',
            Search: 'Пошук...',
            Permissions: 'Дозволи',
            Domains: 'Домени',
            Email: 'E-mail',
            Locale: 'Локація',
            Preview: 'Preview',
            Campaign: 'Кампанія',
            Campaigns: 'Компанії',
            Affiliates: 'Аффілейти',
            Total: 'Усе',
            Slug: 'Скорочення',
            Custom_slug: 'Користувальницьке скорочення',
            Description: 'Опис',
            Event: 'Подія',
            Type: 'Тип',
            Custom: 'Користувальницький',
            Copy_url: 'Копіювати посилання',
            card: 'Карта',
            typeName: 'Назва типу',
            bankName: 'Назва банку',
            holderName: 'Ім\'я власника',
            statusName: 'Назва статусу',
            platformName: 'Назва платформи',
            newTypeName: 'Нова назва типу',
            bank: 'Банк',
            newBankName: 'Нова назва банку',
            holder: 'Утримувач',
            newHolderName: 'Нове ім\'я власника',
            invoice: 'Рахунок',
            invoiceNumber: 'Номер рахунку',
            newInvoiceNumber: 'Новий номер рахунку',
            newStatus: 'Новий статус',
            newPlatformName: 'Нова назва платформи',
            code: 'Код',
            number: 'Номер картки',
            manager: 'Менеджер',
            cvv: 'CVV',
            comment: 'Коментар',
            create: 'Створити',
            edit: 'Редагувати',
            edit_message: 'Редагувати повідомлення',
            remove_message: 'Видалити повідомлення',
            remove: 'Видалити',
            remove_data: 'Видалити дані',
            remove_card: 'Видалити картку?',
            owner: 'Власник',
            link_id: 'Link ID',
            landing_url: 'Url лендінга',
            params_url: 'Параметри url',
            message: 'Повідомлення',
            Start: 'Початок',
            End: 'Кінець',
            Traffic_Type: 'Тип трафіку',
            offer: 'Оффер',
            platform: 'Платформа',
            dateCreate: 'Дата створення',
            view: 'Вид',
            totalLeads: 'Усього лідів',
            active: 'Активні',
            inactive: 'Неактивні',
            No_data: 'Немає даних!',
            PCT: 'PCT',
            Disabled: 'Вимкнено',
            Time: 'Час',
            API: 'API',
            Copy: 'Скопійовано!',
            Value: 'Значення',
            Default_Value: 'Значення за замовчуванням',
            Information: 'Інформація',
            Download: 'Завантажити',
            Action_date: 'ФТД',
            TMP_Action_date: 'Tmp ФТД',
            Supplements: 'Дольоти',
            Lights: 'Лайти',
            today: 'Сьогодні',
            "Post deposits": 'Пост депозити',
            response: 'Лід',
            history_response: 'Відповідь рекламодавця',
            send: 'Надіслано',
            not_send: 'Не відправлено',
            Manager: 'Аффілейт менеджер',
            Endpoint: 'Ресурси',
            Internal_status: 'Внутрішній статус',
            External_status: 'Зовнішній статус',
            campaign_identifier: 'Ідентифікатор кампанії',
            globalEditCaps: 'Глобальне оновлення кап',
            type: 'Тип',
            guarantee: 'Гарант',
            no_guarantee: 'Без гаранта',
            id: 'ID',
            Team_ID: 'ID Команди',
            Group_status: 'Груповий статус',
            Internal: 'Внутрішній',
            External: 'Зовнішній',
            Country_Language: 'Країна/Мова',
            byGeo: 'По гео',
            Advertiser_category: 'Категорія Рекламодавця',
            Category: 'Категорії',
            submitted_fields: 'Поля до відправлення',
            capsByGeo: 'Капи з гео',
            capsByTeams: 'Капи по командам',
            capsByCountries: 'Капи країнами',
            capsAll: 'Загальна капа',
            acceptDuplicates: 'Приймати дублі'
        },
        permissions: {
            Settings_System: 'Системнi налаштування',
            logs: 'Logs',
            finance_access: 'Finance',
            campaign: 'Campaigns',
            dashboard_affiliate: 'A dashboard',
            dashboard_team_leader: 'TL dashboard',
            dashboard_top_management: 'TM dashboard',
            domain: 'Domains',
            finance: 'Finance',
            landing: 'Landings',
            offer: 'Offers',
            team: 'Team',
            statistic_advertiser: 'Advertisers statistics',
            statistic_affiliate: 'Affiliate statistic',
            statistic_lead: 'Lead statistic',
            statistic_offer: 'Offer statistic',
            statistic_falcon: 'Falcon',
            user: 'Users',
            settings_advertiser: 'S Advertiser',
            settings_cap: 'S Cap',
            settings_geo: 'S Geo',
            settings_offer: 'S Offer',
            settings_team: 'S Team',
            settings_domain: 'S Domain',
            settings_landing: 'S Landing',
            settings_hold: 'S Hold',
            settings_campaign_approve: 'S Campaign approve',
            check_lead: 'Check lead',
            update_not_valid: 'Lead update',
            permission: 'Create permission',
            system_status: 'System health',
            postback: 'Postback',
            finance_cards: 'Finance Cards',
            settings_sms_messages: 'Settings sms messages',
            settings_sms_settings: 'Settings sms settings',
            finance_analytic_access: 'Financial analytics',
            settings_management: 'S management',
            settings_status_mapper: 'S status mapper',
            loads: 'Loads',
            recycle_leads: 'Recycle',
            uploads: 'Uploads',
            uploads_falcon: 'Upload falcon',
            uploads_recycle: 'Upload recycle',
            lead_upload_falcon: 'Lead upload falcon',
            affiliate_bot: 'Affiliate notifications'
        },
        calendar: {
            Week: 'Тиждень',
            daysOfWeek: {
                Sunday: 'Неділя',
                Monday: 'Понеділок',
                Tuesday: 'Вівторок',
                Wednesday: 'Середа',
                Thursday: 'Четвер',
                Friday: 'П\'ятниця',
                Saturday: 'Субота'
            },
            daysOfWeek_short: {
                Sun: 'Нд',
                Mon: 'Пн',
                Tue: 'Вт',
                Wed: 'Ср',
                Thu: 'Чт',
                Fri: 'Пт',
                Sat: 'Сб'
            },
            weekdaysMin: {
                Su: 'Нд',
                Mo: 'Пн',
                Tu: 'Вт',
                We: 'Ср',
                Th: 'Чт',
                Fr: 'Пт',
                Sa: 'Сб'
            },
            monthNames_short: {
                Jan: 'Січень',
                Feb: 'Лютий',
                Mar: 'Березень',
                Apr: 'Квітень',
                May: 'Травень',
                Jun: 'Червень',
                Jul: 'Липень',
                Aug: 'Серпень',
                Sep: 'Вересень',
                Oct: 'Жовтень',
                Nov: 'Листопад',
                Dec: 'Грудень'
            },
            sidebar: {
                today: 'Сьогодні',
                yesterday: 'Вчора',
                this_month: 'Поточний місяць',
                last_month: 'Минулий місяць',
                this_year: 'За рік'
            },
            Apply: 'Застосувати',
            Cancel: 'Скасувати'
        },
        system_health: {
            without_advertiser_status: 'Надіслані без статусу',
            without_group_status: 'Надіслані без гр. статусу',
            not_valid: 'Невалідні',
            without_internal_price: 'Без внутрішньої ціни',
            without_external_price: 'Без зовнішньої ціни',
            fa_date_without_gstatus: 'З датою депозиту, без статусу',
            gstatus_without_fa_date: 'Зі статусом, без дати депозиту',
            multiple_success_send: 'Повторна відправка',
        },
        error: {
            duplicate_country_and_lenguage_in_geo: 'Країна {country} з мовою {language} обрана гео - {geo}',
            no_changed_new_owner_or_platform: 'Власник або платформа повинні відрізнятися від поточних',
            messageErrorDomain: 'Невірне ім\'я домену',
            messageDuplicateDomain: 'Ім\'я домену, що повторюється'
        },
        statistic_fields: {
            geo: 'Гео',
            send: 'Надіслати',
            sub1: 'Саб1',
            sub2: 'Саб2',
            sub3: 'Саб3',
            sub4: 'Саб4',
            sub5: 'Саб5',
            sub6: 'Саб6',
            sub7: 'Саб7',
            sub8: 'Саб8',
            sub9: 'Саб9',
            offer: 'Оффер',
            domain: 'Домен',
            status: 'Статис',
            actions: 'Дія',
            country: 'Страна',
            landing: 'Лендінг',
            a_status: 'Статус ліда',
            language: 'Мова',
            personal: 'Інфо',
            s_status: 'Cис_статус',
            affiliate: 'Аффілейт',
            advertiser: 'Рекламодавець',
            adv_history: 'Рек_історія',
            registration: 'Реєстрація',
            sms: 'СМС',
            id: 'ID',
            lead_id: 'Lead ID'
        },
        card_statuses: {
            new: 'Нова',
            active: 'Активна',
            inactive: 'Неактивна',
            closed: 'Закрита',
            unknown: 'Невідомий статус'
        },
        table: {
            No_data_available: 'Немає даних!',
            AVG_Price: 'Середня ціна',
            CR: 'CR%',
            sendedLeads: 'Надіслані',
            duplicateLeads: 'Дублікати',
            trash: 'Tреш',
            team_ID: 'ID команди',
            Traffic_model: 'Модель виплати',
            Is_internal: 'Внутрішній',
            Is_internal_team: 'Внутрішній',
            Global_status: 'Глобальний статус',
            Global_actions: 'Глобальні дії',
            Total_cap: 'Усі капи',
            Campaign_ID: 'ID кампанії',
            Ex_price: 'Ex. price',
            Int_price: 'Int. price',
            Internal_price_summ: 'Total Revenue',
            External_price_summ: 'Total Pay out',
            isHot: 'Гарячий трафік',
            autologin: 'Автологін'
        },
        tooltip: {
            allStatuses: 'За всіма статусами',
            Download_CSV: 'Завантажити в CSV',
            Watch_full_stats: 'Переглянути повну статистику',
            Copy: 'Копіювати',
            Copy_password: 'Копіювати пароль',
            Show: 'Показати',
            Hide: 'Приховати',
            Reset_filter: 'Скинути фільтр',
            Refresh_table: 'Оновити таблицю',
            Delete_integration: 'Видалити інтеграцію',
            Stop_traffic: 'Зупинити трафік',
            Start_traffic: 'Запустити трафік',
            Update_traffic: 'Оновити трафік',
            Add_country_and_language: 'Додати країну та мову',
            Delete_country_and_language: 'Видалити країну та мову',
            Active_card: 'Активувати картку',
            Deactive_card: 'Деактивувати картку',
            Change_owner_or_platform: 'Змінити власника або платформу',
            Close_card: 'Закрити карту',
            Login_as_this_user: 'Увійти під цим користувачем',
            Download_list_domains: 'Завантажити список доменів',
            Temporary_depositor: 'Тимчасовий депозитор',
            Comment: 'Коментар',
            add_param: 'Додати параметр',
            delete_param: 'Видалити параметр',
            delete_advertiser: 'Видалити рекламодавця',
            Group_by_advertiser: 'Групувати за рекламодавцями',
            Undo_grouping: 'Скасувати угруповання',
            Delete: 'Видалити',
            detailsTeam: 'Список команд',
            detailsAdvertisers: 'Список рекламодавців',
            toTrash: 'Відправити у треш',
            clearErrors: 'Очистити помилки',
            cold_traffic: 'Низький пріоритет',
            edit_time: 'Редагувати час',
            updateStatus: 'Оновити РЕК статус',
            scheduling_caps: "Розклад кап",
            set_caps: "Значення кап",
            statusPart: "Є угоди з низьким пріоритетом",
            statusAll: "Усі угоди з низьким пріоритетом",
            statusNone: "Немає угод із низьким пріоритетом",
            lowPriority: "Низький пріоритет",
            highPriority: "Високий пріоритет",
            view: 'Переглянути',
            upload: 'Завантажити',
            remove: 'Видалити',
            Resend: 'Перевідправити',
            reindexing: 'Переіндексація'
        },
        confirm: {
            removeAutomation: 'Ви збираєтесь видалити автоматизацію!',
            deactivateStatus: 'Ви збираєтеся ДЕАКТИВУВАТИ системний статус!',
            activateStatus: 'Ви збираєтеся АКТИВУВАТИ системний статус!',
            Confirm_action: 'Підтвердити дію',
            activateAdvertiser: 'Ви збираєтеся АКТИВУВАТИ рекламодавця!',
            deactivateAdvertiser: 'Ви збираєтеся ДЕАКТИВУВАТИ рекламодавця!',
            activateIntegration: 'Ви збираєтеся АКТИВУВАТИ інтеграцію!',
            deactivateIntegration: 'Ви збираєтеся ДЕАКТИВУВАТИ інтеграцію!',
            deleteIntegration: 'Ви збираєтесь ВИДАЛИТИ інтеграцію!',
            clearQueue: 'Ви впевнені, що хочете очистити чергу?',
            refreshTraffic: 'Оновити трафік у цій інтеграції?',
            stopTrafficOnIntegration: 'Зупинити трафік у цій інтеграції?',
            startTrafficOnIntegration: 'Запустити трафік у цій інтеграції?',
            btnStopTrafficOnIntegration: 'Зупинити',
            btnStartTrafficOnIntegration: 'Запустити',
            deactivateOffer: 'Ви збираєтеся ДЕАКТИВУВАТИ oффер!',
            activateOffer: 'Ви збираєтеся АКТИВУВАТИ oффер!',
            deactivateLanding: 'Ви збираєтеся ДЕАКТИВУВАТИ лендінг!',
            activateLanding: 'Ви збираєтеся АКТИВУВАТИ лендінг!',
            deactivateDomain: 'Ви збираєтеся ДЕАКТИВУВАТИ домен!',
            activateDomain: 'Ви збираєтеся АКТИВУВАТИ домен!',
            deleteMessage: 'Ви впевнені, що хочете видалити це повідомлення?',
            deleteMessageSettings: 'Ви впевнені, що хочете видалити це налаштування?',
            deactivateUser: 'Ви збираєтеся ДЕАКТИВУВАТИ користувача!',
            activateUser: 'Ви збираєтеся АКТИВУВАТИ користувача!',
            activatePostback: 'Ви збираєтеся АКТИВУВАТИ постбек!',
            deactivatePostback: 'Ви збираєтеся ДЕАКТИВУВАТИ постбек!',
            deactivateСampaign: 'Ви збираєтеся ДЕАКТИВУВАТИ кампанію!',
            activateСampaign: 'Ви збираєтеся АКТИВУВАТИ кампанію!',
            disapproveСampaign: 'Ви хочете НЕ СТВЕРДЖУВАТИ кампанію!',
            approveСampaign: 'Ви збираєтесь ЗАТВЕРДИТИ кампанію!',
            deactivateСard: 'Ви впевнені, що хочете ДЕАКТИВУВАТИ карту?',
            activateСard: 'Ви впевнені, що хочете АКТИВУВАТИ картку?',
            deactivateHold: 'Ви збираєтеся ДЕАКТИВУВАТИ холд!',
            activateHold: 'Ви збираєтеся АКТИВУВАТИ холд!',
            closeCard: 'Ви впевнені, що хочете ЗАКРИТИ картку?',
            openCard: 'Ви впевнені, що хочете ВІДКРИТИ карту?',
            changeOwnerOrPlatform: 'Ви збираєтеся змінити менеджера чи платформу!',
            deactivateTeam: 'Ви збираєтеся ДЕАКТИВУВАТИ команду!',
            activateTeam: 'Ви збираєтеся АКТИВУВАТИ команду!',
            destroyAdvertiser: 'Ви впевнені, що хочете ВИДАЛИТИ рекламодавця?',
            clearErrors: 'Ви впевнені, що хочете ОЧИСТИТИ помилки?',
            removeLeads: 'Ви впевнені, що хочете видалити всі ліди?',
            confirm: 'Підтвердити'
        },
        label: {
            Sync_available: 'Синхронізація',
            Only_hot_trafic: 'Тільки гарячий трафік',
            team_status: 'Активна',
            Choose_advertiser: 'Виберіть рекламодавця',
            Choose_integration: 'Виберіть інтеграцію',
            External_price: 'Pay out',
            Internal_price: 'Revenue',
            percent: 'Відсоток',
            guarantee: 'Гарантія',
            new_path: 'Новий шлях',
            Free_domains: 'Вільні домени',
            Event_type: 'Тип події',
            Parameter_name: 'Назва параметра',
            Postbacks: 'Постбеки',
            Advertisers_history: 'Історія рекламодавців',
            Unvalid: 'Невалідний/%',
            Valid: 'Валідний',
            Summ: 'Сума',
            changeParameter: 'Змінити параметр',
            enterKey: 'Введіть ключ',
            enterValue: 'Введіть значення'
        },
        page_404: {
            Title: '404 Сторінка не знайдена!',
            Back_previous: 'Повернутися на попередню сторінку',
            Back_home: 'Повернутися на головну'
        },
        not_authorized: {
            Title: 'Ви не авторизовані!'
        },
        table_filters: {
            sub: 'Саб',
            advertisers: 'Рекламодавець',
            advertisers_categories: 'Категорія Рекламодавця',
            affiliates: 'Аффілейт',
            countries: 'Країна',
            external_price: 'Зовнішня ціна',
            geos: 'Гео',
            geo: 'Гео',
            integrations: 'Інтеграція',
            internal_price: 'Внутрішня ціна',
            statuses: 'Статус',
            traffic_models: 'Модель виплати',
            advertiser_id: 'Рекламодавець',
            domains: 'Домен',
            advertiser_integration_id: 'Інтеграція',
            traffic_model_id: 'Модель виплати',
            team_id: 'Команда',
            teams: 'Команда',
            affiliate_hash: 'Аффілейт',
            group_statuses: 'Статус',
            language: 'Мова',
            country: 'Країна',
            offer_name: 'Оффер',
            offers: 'Оффер',
            landing_name: 'Лендінг',
            group_status: 'Статус',
            team_name: 'Команда',
            role_name: 'Роль',
            active_name: 'Статус',
            affiliate_id: 'Аффілейт',
            advertiser_integration: 'Інтеграція',
            affiliate_name: 'Аффілейт',
            domain: 'Домен',
            affiliate: 'Аффілейт',
            offer: 'Оффер',
            languages: 'Мова',
            approve: 'Затвердити',
            status: 'Статус',
            manager_id: "Аффілейт менеджер",
            guarantee: 'Гарантія',
            advertiser_categories: 'Категорія Рекламодавця',
            pay_out: 'Pay out',
            email: 'Email',
            first_name: 'Ім\'я',
            last_name: 'Прізвище',
            lead_id: 'Lead id',
            lead_status: 'Статус',
            phone: 'Телефон',
            currency: 'Валюта',
            manager: 'Менеджер'
        },
        server_filter: {
            advertisers: 'Рекламодавець',
            integrations: 'Інтеграція',
            traffic_models: 'Модель виплати',
            affiliate_id: 'Аффілейт',
            affiliates: 'Аффілейт',
            geos: 'Гео',
            teams: 'Команда',
            offers: 'Оффер',
            domains: 'Домен',
            advertiser_integration: 'Інтеграція',
            countries: "Країна",
            status: 'Статус',
            approve: 'Затвердити',
            language: 'Мова',
            languages: 'Мова',
            affiliate: 'Аффілейт',
            offer: 'Оффер',
            domain: 'Домен',
            all: 'Всі',
            is_active: "Статус",
            is_approved: "Затвердити"
        },
        validationErrors: {
            unique: 'Значення має бути унікальним',
            floatOrInteger: 'Поле {name} не є коректним',
            integer: 'Поле {name} має бути цілим числом',
            required: 'Поле {name} є обов\'язковим',
            minmax: 'Мінімально {minimum}, максимально {maximum}',
            max_value: 'Максимальне значення: {max}',
            min: 'Мінімальне значення: {min}',
            max: 'Максимальне значення: {max}',
            email: 'Некоректна email адреса',
            is_not: 'Значення недійсне',
            confirmed: '{target} не збігається',
            ip: 'Некоректна IP адреса',
            numeric: 'Поле {name} є числовим',
            negativeNumber: 'Поле {name} не може бути негативним числом',
            url: 'Некоректна Url адреса',
            incorrect_value: 'Неправильне значення',
            incorrect_card_number: 'Некоректний номер картки',
            incorrect_cvv: 'Некоректний CVV',
            errorAddTitle: 'Домени не додані',
            string: 'Поле {name} Має бути рядком',
            incorrect_phone_number: 'Невірний номер телефону',
            maxNum: 'Перевищено максимальне значення в {target}',
            minNum: 'Мінімальне значення не може бути менше {target}',
            gte: 'Значення має бути більше або дорівнювати полю: {targetName}'
        },
        bgErrors: {
            different: 'Поле має бути унікальним',
            unique: 'Поле має бути унікальним',
            integer: 'Поле має бути цілим числом',
            required: 'Поле має бути заповнено',
            max: 'Перевищено максимальний ліміт',
            regex: 'Невірний формат',
            uniqueDomain: 'Такий домен вже існує',
            unknown: 'Невідома помилка'
        },
        notification: {
            error: 'Помилка',
            success: 'Скопійовано!',
            errorMessage: 'Щось пішло не так!'
        },
        leadCount: {
            'sended': 'Надіслані',
            'hold': 'Холд',
            'not_valid': 'Невалідні',
            'trash': 'Tреш',
            'duplicate': 'Дублікати',
            'double': 'Дублікати',
            'leads': 'Надіслані',
            'pending': 'У перенаправленні',
            'sent': 'Перенаділені',
            'failed': 'Помилка відправлення',
            'sended_false': 'Вiдхиленнi',
        },
        date: {
            send_date: "За датою відправки",
            created_at: "За датою реєстрації",
            first_action_date: "За датою депозиту"
        },
        tab: {
            internal_response: 'Внутрішня відповідь',
            external_response: 'Зовнішня відповідь',
            lead_test: 'Тест Ліда',
            sync_status: 'Тест синхронізації'
        },
        upload: {
            title: 'Перетягніть або виберіть потрібний файл.',
            size: 'Розмір файлу не повинен перевищувати {size} МБ.',
            notValidFields: 'CSV має невалідні поля!',
            notValidUniqueFields: 'CSV має повторювані поля!'
        },
        system_settings: {
            'category': {
                thank_you_page: 'Thank you page',
                settings_teams: 'Налаштування -> команди',
                settings_advertisers: 'Налаштування -> рекламодавці',
                logs: 'Логи',
                lead_acceptance: 'Прийомка ліда',
                global: 'Глобальні',
                finance_analytics: 'Фінанси аналітика'
            },
            'title': {
                'is_falcon_long-term_synchronization_allowed': 'Довгострокова синхронізація статусу Falcon',
                'is_demo_data_allowed': 'Дозволяє демонстраційні дані',
                'lead_blacklist_ip': 'Чорний список IP-адрес',
                'invalid_statuses': 'Список неприпустимих статусів',
                'write_integration_statuses_history_log': 'Писати лог по синхронізованим статусам',
                'clean_request_logs_after_days': 'Час життя request logs',
                'clean_version_logs_after_days': 'Час життя  version logs',
                'clean_lead_logs_after_days': 'Час життя lead logs',
                'teams_with_required_lead_ip': 'Команди з обов\'язковим полем ip ліда при створенні ліда',
                'thank_you_page_expired_url': 'Thank you page expired url',
                'thank_you_page_url_lifetime_minutes': 'Час життя thank you page',
                'teams_show_users': 'Показати користувачів у команді',
                'teams_show_integrations': 'Показати інтеграцію у команді',
                'advertisers_show_integrations_and_geo': 'Показати інтеграцію та гео у рекламодавців',
                'lead_duplicate_check_days_prior': 'Період перевірки дублікатів ліда (у днях)',
                'lead_duplicate_check_days_prior_for_deposit': 'Період перевірки дублікатів ліда для депозитів (у днях)',
                'lead_expiration_status_after_days_for_falcon': 'Термін закінчення ліда (у днях) для Falcon',
                'lead_expiration_status_after_days_for_non_falcon': 'Термін закінчення ліда (у днях) для non-Falcon',
                'lead_expiration_status_changeable_statuses_list': 'Список змінюваних статусів закінчення ліда',
                'reconcile_extended_for_types': 'Розширене звіряння для типів'
            },
            'description': {
                'is_falcon_long-term_synchronization_allowed': 'Дозволяє синхронізувати статус протягом більше 45 днів',
                'teams_show_users': 'Показувати колонку `users` в таблиці',
                'teams_show_integrations':  'Показувати колонку `integrations` в таблиці',
                'advertisers_show_integrations_and_geo': 'Показувати колонки `integrations` та `geo`в таблиці',
                'is_demo_data_allowed': 'Дозволяє демонстраційні данні',
                'lead_blacklist_ip': 'Чорний список IP-адресів',
                'invalid_statuses': 'Список неприпустимих статусів, розділених комами',
                'write_integration_statuses_history_log': 'Писати лог по синхронізованих статусах таблиця `lead_statuses`',
                'clean_request_logs_after_days': 'Час життя request logs в днях',
                'clean_version_logs_after_days': 'Час життя version logs в днях',
                'clean_lead_logs_after_days': 'Час життя lead logs в днях',
                'teams_with_required_lead_ip': 'Комнди з обов\'язковим полем ip ліда при створенні ліда',
                'thank_you_page_url_lifetime_minutes': 'Час життя Thank you page url lifetime у хвилинах',
                'thank_you_page_expired_url': 'Thank you page expired url',
                'lead_duplicate_check_days_prior': 'Період перевірки дублікатів ліда (у днях)',
                'lead_duplicate_check_days_prior_for_deposit': 'Період перевірки дублікатів ліда для депозитів (у днях)',
                'lead_expiration_status_after_days_for_falcon': 'Строк завершення ліда (у днях) для Falcon',
                'lead_expiration_status_after_days_for_non_falcon': 'Строк завершення ліда (у днях) для non-Falcon',
                'lead_expiration_status_changeable_statuses_list': 'Список статусів завершення ліда, які можна змінювати',
                'reconcile_extended_for_types': 'Дозволяє використовувати розширене звіряння для вибраних типів даних.'
            },
        },
        notifications: {
            channels: 'Канали',
            send_to_all_channels: 'Відправити у всі канали'
        }
    }
}
